import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_engine_effect_proto from './dcei_engine_effect_proto';
import * as dcei_engine_expression_proto from './dcei_engine_expression_proto';
export class Mover {
  get descriptor() {
    return Mover.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofMotionTypeCase = 0;
    this._oneofMotionTypeValue = null;
    this._hasUpright = false;
    this._upright = null;
    this._hasNoRotation = false;
    this._noRotation = null;
    this._hasStayOnNavMesh = false;
    this._stayOnNavMesh = null;
    this._hasComment = false;
    this._comment = null;
  }
  isEmpty() {
    if (this._oneofMotionTypeCase !== 0) return false;
    if (this._hasUpright) return false;
    if (this._hasNoRotation) return false;
    if (this._hasStayOnNavMesh) return false;
    if (this._hasComment) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Mover) {
      return value;
    }
    return Mover.fromJson(value);
  }
  static fromJson(json) {
    const result = new Mover();
    if (json.guidance != null) {
      result._oneofMotionTypeCase = 1;
      result._oneofMotionTypeValue = GuidanceMover.fromJson(json.guidance);
    }
    if (json.ballistic != null) {
      result._oneofMotionTypeCase = 2;
      result._oneofMotionTypeValue = BallisticMover.fromJson(json.ballistic);
    }
    if (json.sineWave != null) {
      result._oneofMotionTypeCase = 3;
      result._oneofMotionTypeValue = SineWaveMover.fromJson(json.sineWave);
    }
    if (json.orbiting != null) {
      result._oneofMotionTypeCase = 4;
      result._oneofMotionTypeValue = OrbitingMover.fromJson(json.orbiting);
    }
    if (json.upright != null) {
      result._hasUpright = true;
      result._upright = JsonToBoolean.fromJson(json.upright);
    }
    if (json.noRotation != null) {
      result._hasNoRotation = true;
      result._noRotation = JsonToBoolean.fromJson(json.noRotation);
    }
    if (json.stayOnNavMesh != null) {
      result._hasStayOnNavMesh = true;
      result._stayOnNavMesh = JsonToBoolean.fromJson(json.stayOnNavMesh);
    }
    if (json.comment != null) {
      result._hasComment = true;
      result._comment = JsonToString.fromJson(json.comment);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofMotionTypeCase) {
      case 1:
        result.guidance = GuidanceMover.toJson(this._oneofMotionTypeValue);
        break;
      case 2:
        result.ballistic = BallisticMover.toJson(this._oneofMotionTypeValue);
        break;
      case 3:
        result.sineWave = SineWaveMover.toJson(this._oneofMotionTypeValue);
        break;
      case 4:
        result.orbiting = OrbitingMover.toJson(this._oneofMotionTypeValue);
        break;
      default:
        break;
    }
    if (this._hasUpright) {
      result.upright = JsonToBoolean.toJson(this._upright);
    }
    if (this._hasNoRotation) {
      result.noRotation = JsonToBoolean.toJson(this._noRotation);
    }
    if (this._hasStayOnNavMesh) {
      result.stayOnNavMesh = JsonToBoolean.toJson(this._stayOnNavMesh);
    }
    if (this._hasComment) {
      result.comment = JsonToString.toJson(this._comment);
    }
    return result;
  }
  get oneofMotionTypeCase() {
    return this._oneofMotionTypeCase;
  }
  deleteOneofMotionType(path) {
    switch (this._oneofMotionTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['guidance'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['ballistic'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['sineWave'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['orbiting'])};
      }
    }
  }
  /**
   * @returns {GuidanceMover}
   */
  get guidance() {
    return this._oneofMotionTypeCase === 1 ? this._oneofMotionTypeValue : GuidanceMover.default;
  }
  setGuidance(path, value) {
    return {type: 'SET', path: path.concat(['guidance']), value: value.toJson()};
  }
  deleteGuidance(path) {
    return {type: 'DELETE', path: path.concat(['guidance'])};
  }
  /**
   * @returns {BallisticMover}
   */
  get ballistic() {
    return this._oneofMotionTypeCase === 2 ? this._oneofMotionTypeValue : BallisticMover.default;
  }
  setBallistic(path, value) {
    return {type: 'SET', path: path.concat(['ballistic']), value: value.toJson()};
  }
  deleteBallistic(path) {
    return {type: 'DELETE', path: path.concat(['ballistic'])};
  }
  /**
   * @returns {SineWaveMover}
   */
  get sineWave() {
    return this._oneofMotionTypeCase === 3 ? this._oneofMotionTypeValue : SineWaveMover.default;
  }
  setSineWave(path, value) {
    return {type: 'SET', path: path.concat(['sineWave']), value: value.toJson()};
  }
  deleteSineWave(path) {
    return {type: 'DELETE', path: path.concat(['sineWave'])};
  }
  /**
   * @returns {OrbitingMover}
   */
  get orbiting() {
    return this._oneofMotionTypeCase === 4 ? this._oneofMotionTypeValue : OrbitingMover.default;
  }
  setOrbiting(path, value) {
    return {type: 'SET', path: path.concat(['orbiting']), value: value.toJson()};
  }
  deleteOrbiting(path) {
    return {type: 'DELETE', path: path.concat(['orbiting'])};
  }
  /**
   * @returns {boolean}
   */
  get upright() {
    return this._hasUpright ? this._upright : JsonToBoolean.default;
  }
  get hasUpright() {
    return this._hasUpright;
  }
  setUpright(path, value) {
    return {type: 'SET', path: path.concat(['upright']), value};
  }
  deleteUpright(path) {
    return {type: 'DELETE', path: path.concat(['upright'])};
  }
  /**
   * @returns {boolean}
   */
  get noRotation() {
    return this._hasNoRotation ? this._noRotation : JsonToBoolean.default;
  }
  get hasNoRotation() {
    return this._hasNoRotation;
  }
  setNoRotation(path, value) {
    return {type: 'SET', path: path.concat(['noRotation']), value};
  }
  deleteNoRotation(path) {
    return {type: 'DELETE', path: path.concat(['noRotation'])};
  }
  /**
   * @returns {boolean}
   */
  get stayOnNavMesh() {
    return this._hasStayOnNavMesh ? this._stayOnNavMesh : JsonToBoolean.default;
  }
  get hasStayOnNavMesh() {
    return this._hasStayOnNavMesh;
  }
  setStayOnNavMesh(path, value) {
    return {type: 'SET', path: path.concat(['stayOnNavMesh']), value};
  }
  deleteStayOnNavMesh(path) {
    return {type: 'DELETE', path: path.concat(['stayOnNavMesh'])};
  }
  /**
   * @returns {string}
   */
  get comment() {
    return this._hasComment ? this._comment : JsonToString.default;
  }
  get hasComment() {
    return this._hasComment;
  }
  setComment(path, value) {
    return {type: 'SET', path: path.concat(['comment']), value};
  }
  deleteComment(path) {
    return {type: 'DELETE', path: path.concat(['comment'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "guidance": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mover(this);
              copy._oneofMotionTypeCase = 1;
              copy._oneofMotionTypeValue = GuidanceMover.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofMotionTypeCase !== 1) {
                return this;
              }
              const copy = new Mover(this);
              copy._oneofMotionTypeCase = 0;
              copy._oneofMotionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofMotionTypeCase !== 1) {
            const copy = new Mover(this);
            copy._oneofMotionTypeCase = 1;
            copy._oneofMotionTypeValue = GuidanceMover.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.guidance.apply(type, path.slice(1), value);
          if (newValue === this.guidance) {
            return this;
          }
          const copy = new Mover(this);
          copy._oneofMotionTypeCase = 1;
          copy._oneofMotionTypeValue = newValue;
          return copy;
        }
      }
      case "ballistic": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mover(this);
              copy._oneofMotionTypeCase = 2;
              copy._oneofMotionTypeValue = BallisticMover.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofMotionTypeCase !== 2) {
                return this;
              }
              const copy = new Mover(this);
              copy._oneofMotionTypeCase = 0;
              copy._oneofMotionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofMotionTypeCase !== 2) {
            const copy = new Mover(this);
            copy._oneofMotionTypeCase = 2;
            copy._oneofMotionTypeValue = BallisticMover.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.ballistic.apply(type, path.slice(1), value);
          if (newValue === this.ballistic) {
            return this;
          }
          const copy = new Mover(this);
          copy._oneofMotionTypeCase = 2;
          copy._oneofMotionTypeValue = newValue;
          return copy;
        }
      }
      case "sineWave": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mover(this);
              copy._oneofMotionTypeCase = 3;
              copy._oneofMotionTypeValue = SineWaveMover.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofMotionTypeCase !== 3) {
                return this;
              }
              const copy = new Mover(this);
              copy._oneofMotionTypeCase = 0;
              copy._oneofMotionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofMotionTypeCase !== 3) {
            const copy = new Mover(this);
            copy._oneofMotionTypeCase = 3;
            copy._oneofMotionTypeValue = SineWaveMover.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.sineWave.apply(type, path.slice(1), value);
          if (newValue === this.sineWave) {
            return this;
          }
          const copy = new Mover(this);
          copy._oneofMotionTypeCase = 3;
          copy._oneofMotionTypeValue = newValue;
          return copy;
        }
      }
      case "orbiting": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mover(this);
              copy._oneofMotionTypeCase = 4;
              copy._oneofMotionTypeValue = OrbitingMover.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofMotionTypeCase !== 4) {
                return this;
              }
              const copy = new Mover(this);
              copy._oneofMotionTypeCase = 0;
              copy._oneofMotionTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofMotionTypeCase !== 4) {
            const copy = new Mover(this);
            copy._oneofMotionTypeCase = 4;
            copy._oneofMotionTypeValue = OrbitingMover.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.orbiting.apply(type, path.slice(1), value);
          if (newValue === this.orbiting) {
            return this;
          }
          const copy = new Mover(this);
          copy._oneofMotionTypeCase = 4;
          copy._oneofMotionTypeValue = newValue;
          return copy;
        }
      }
      case "upright": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mover(this);
              copy._hasUpright = true;
              copy._upright = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUpright) {
                return this;
              }
              const copy = new Mover(this);
              copy._hasUpright = false;
              copy._upright = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "noRotation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mover(this);
              copy._hasNoRotation = true;
              copy._noRotation = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNoRotation) {
                return this;
              }
              const copy = new Mover(this);
              copy._hasNoRotation = false;
              copy._noRotation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stayOnNavMesh": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mover(this);
              copy._hasStayOnNavMesh = true;
              copy._stayOnNavMesh = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStayOnNavMesh) {
                return this;
              }
              const copy = new Mover(this);
              copy._hasStayOnNavMesh = false;
              copy._stayOnNavMesh = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "comment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Mover(this);
              copy._hasComment = true;
              copy._comment = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComment) {
                return this;
              }
              const copy = new Mover(this);
              copy._hasComment = false;
              copy._comment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Mover} other
   * @returns {Mover}
   */
  merge(other) {
    const copy = new Mover(this);
    if (other._oneofMotionTypeCase === 1) {
      if (this._oneofMotionTypeCase === 1) {
        copy._oneofMotionTypeValue = copy._oneofMotionTypeValue.merge(other._oneofMotionTypeValue);
      } else {
        copy._oneofMotionTypeValue = other._oneofMotionTypeValue;
      }
      copy._oneofMotionTypeCase = 1;
    }
    if (other._oneofMotionTypeCase === 1) {
      if (this._oneofMotionTypeCase === 1) {
        copy._oneofMotionTypeValue = copy._oneofMotionTypeValue.merge(other._oneofMotionTypeValue);
      } else {
        copy._oneofMotionTypeValue = other._oneofMotionTypeValue;
      }
      copy._oneofMotionTypeCase = 1;
    }
    if (other._oneofMotionTypeCase === 1) {
      if (this._oneofMotionTypeCase === 1) {
        copy._oneofMotionTypeValue = copy._oneofMotionTypeValue.merge(other._oneofMotionTypeValue);
      } else {
        copy._oneofMotionTypeValue = other._oneofMotionTypeValue;
      }
      copy._oneofMotionTypeCase = 1;
    }
    if (other._oneofMotionTypeCase === 1) {
      if (this._oneofMotionTypeCase === 1) {
        copy._oneofMotionTypeValue = copy._oneofMotionTypeValue.merge(other._oneofMotionTypeValue);
      } else {
        copy._oneofMotionTypeValue = other._oneofMotionTypeValue;
      }
      copy._oneofMotionTypeCase = 1;
    }
    if (other._hasUpright) {
      copy._hasUpright = true;
      copy._upright = other._upright;
    }
    if (other._hasNoRotation) {
      copy._hasNoRotation = true;
      copy._noRotation = other._noRotation;
    }
    if (other._hasStayOnNavMesh) {
      copy._hasStayOnNavMesh = true;
      copy._stayOnNavMesh = other._stayOnNavMesh;
    }
    if (other._hasComment) {
      copy._hasComment = true;
      copy._comment = other._comment;
    }
    return copy;
  }
}
Mover.default = new Mover();
class Mover_Builder {
  constructor(value) {
    this._value = new Mover(value);
  }
  build() {
    return new Mover(this._value);
  }
  clearoneofMotionType() {
    this._value._oneofMotionTypeCase = 0;
    this._value._oneofMotionTypeValue = null;
    return this;
  }
  setGuidance(value) {
    this._value._oneofMotionTypeCase = 1;
    this._value._oneofMotionTypeValue = value;
    return this;
  }
  setBallistic(value) {
    this._value._oneofMotionTypeCase = 2;
    this._value._oneofMotionTypeValue = value;
    return this;
  }
  setSineWave(value) {
    this._value._oneofMotionTypeCase = 3;
    this._value._oneofMotionTypeValue = value;
    return this;
  }
  setOrbiting(value) {
    this._value._oneofMotionTypeCase = 4;
    this._value._oneofMotionTypeValue = value;
    return this;
  }
  setUpright(value) {
    this._value._hasUpright = true;
    this._value._upright = value;
    return this;
  }
  deleteUpright() {
    this._value._hasUpright = false;
    this._value._upright = null;
    return this;
  }
  setNoRotation(value) {
    this._value._hasNoRotation = true;
    this._value._noRotation = value;
    return this;
  }
  deleteNoRotation() {
    this._value._hasNoRotation = false;
    this._value._noRotation = null;
    return this;
  }
  setStayOnNavMesh(value) {
    this._value._hasStayOnNavMesh = true;
    this._value._stayOnNavMesh = value;
    return this;
  }
  deleteStayOnNavMesh() {
    this._value._hasStayOnNavMesh = false;
    this._value._stayOnNavMesh = null;
    return this;
  }
  setComment(value) {
    this._value._hasComment = true;
    this._value._comment = value;
    return this;
  }
  deleteComment() {
    this._value._hasComment = false;
    this._value._comment = null;
    return this;
  }
}
Mover.Builder = Mover_Builder;
class Mover_WithParent {
  /**
   * @param {Mover} value
   * @param {Mover_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Mover.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofMotionTypeCase() {
    if (this._cachedoneofMotionTypeCase === undefined) {
      if (this._value._oneofMotionTypeCase === 0) {
        this._cachedoneofMotionTypeCase = this._parent ? this._parent.oneofMotionTypeCase : 0;
      } else {
        this._cachedoneofMotionTypeCase = this._value._oneofMotionTypeCase;
      }
    }
    return this._cachedoneofMotionTypeCase;
  }
  get guidance() {
    if (!this._cachedGuidance) {
      if (this._value._oneofMotionTypeCase === 0) {
        this._cachedGuidance = this._parent ? new GuidanceMover.WithParent(GuidanceMover.default, this._parent.guidance) : this._value.guidance;
      } else if (this._value._oneofMotionTypeCase === 1) {
        this._cachedGuidance = new GuidanceMover.WithParent(this._value.guidance, this._parent && this._parent.oneofMotionTypeCase === 1 ? this._parent.guidance : null);
      } else {
        this._cachedGuidance = GuidanceMover.WithParent.default;
      }
    }
    return this._cachedGuidance;
  }
  get ballistic() {
    if (!this._cachedBallistic) {
      if (this._value._oneofMotionTypeCase === 0) {
        this._cachedBallistic = this._parent ? new BallisticMover.WithParent(BallisticMover.default, this._parent.ballistic) : this._value.ballistic;
      } else if (this._value._oneofMotionTypeCase === 2) {
        this._cachedBallistic = new BallisticMover.WithParent(this._value.ballistic, this._parent && this._parent.oneofMotionTypeCase === 2 ? this._parent.ballistic : null);
      } else {
        this._cachedBallistic = BallisticMover.WithParent.default;
      }
    }
    return this._cachedBallistic;
  }
  get sineWave() {
    if (!this._cachedSineWave) {
      if (this._value._oneofMotionTypeCase === 0) {
        this._cachedSineWave = this._parent ? new SineWaveMover.WithParent(SineWaveMover.default, this._parent.sineWave) : this._value.sineWave;
      } else if (this._value._oneofMotionTypeCase === 3) {
        this._cachedSineWave = new SineWaveMover.WithParent(this._value.sineWave, this._parent && this._parent.oneofMotionTypeCase === 3 ? this._parent.sineWave : null);
      } else {
        this._cachedSineWave = SineWaveMover.WithParent.default;
      }
    }
    return this._cachedSineWave;
  }
  get orbiting() {
    if (!this._cachedOrbiting) {
      if (this._value._oneofMotionTypeCase === 0) {
        this._cachedOrbiting = this._parent ? new OrbitingMover.WithParent(OrbitingMover.default, this._parent.orbiting) : this._value.orbiting;
      } else if (this._value._oneofMotionTypeCase === 4) {
        this._cachedOrbiting = new OrbitingMover.WithParent(this._value.orbiting, this._parent && this._parent.oneofMotionTypeCase === 4 ? this._parent.orbiting : null);
      } else {
        this._cachedOrbiting = OrbitingMover.WithParent.default;
      }
    }
    return this._cachedOrbiting;
  }
  get hasUpright() {
    if (this._cachedHasUpright === undefined) {
      if (this._value.hasUpright) {
        this._cachedHasUpright = true;
      } else {
        this._cachedHasUpright = this._parent ? this._parent.hasUpright : false;
      }
    }
    return this._cachedHasUpright;
  }
  get upright() {
    if (this._cachedUpright === undefined) {
      if (this._value.hasUpright) {
        this._cachedUpright = this._value.upright;
      } else {
        this._cachedUpright = this._parent ? this._parent.upright : this._value.upright;
      }
    }
    return this._cachedUpright;
  }
  get hasNoRotation() {
    if (this._cachedHasNoRotation === undefined) {
      if (this._value.hasNoRotation) {
        this._cachedHasNoRotation = true;
      } else {
        this._cachedHasNoRotation = this._parent ? this._parent.hasNoRotation : false;
      }
    }
    return this._cachedHasNoRotation;
  }
  get noRotation() {
    if (this._cachedNoRotation === undefined) {
      if (this._value.hasNoRotation) {
        this._cachedNoRotation = this._value.noRotation;
      } else {
        this._cachedNoRotation = this._parent ? this._parent.noRotation : this._value.noRotation;
      }
    }
    return this._cachedNoRotation;
  }
  get hasStayOnNavMesh() {
    if (this._cachedHasStayOnNavMesh === undefined) {
      if (this._value.hasStayOnNavMesh) {
        this._cachedHasStayOnNavMesh = true;
      } else {
        this._cachedHasStayOnNavMesh = this._parent ? this._parent.hasStayOnNavMesh : false;
      }
    }
    return this._cachedHasStayOnNavMesh;
  }
  get stayOnNavMesh() {
    if (this._cachedStayOnNavMesh === undefined) {
      if (this._value.hasStayOnNavMesh) {
        this._cachedStayOnNavMesh = this._value.stayOnNavMesh;
      } else {
        this._cachedStayOnNavMesh = this._parent ? this._parent.stayOnNavMesh : this._value.stayOnNavMesh;
      }
    }
    return this._cachedStayOnNavMesh;
  }
  get hasComment() {
    if (this._cachedHasComment === undefined) {
      if (this._value.hasComment) {
        this._cachedHasComment = true;
      } else {
        this._cachedHasComment = this._parent ? this._parent.hasComment : false;
      }
    }
    return this._cachedHasComment;
  }
  get comment() {
    if (this._cachedComment === undefined) {
      if (this._value.hasComment) {
        this._cachedComment = this._value.comment;
      } else {
        this._cachedComment = this._parent ? this._parent.comment : this._value.comment;
      }
    }
    return this._cachedComment;
  }
  update(current, parent) {
    const result = new Mover_WithParent(current, parent);
    if (this._cachedGuidance && this._value._oneofMotionTypeCase === 1 && current._oneofMotionTypeCase === 1) {
      if (this._value.guidance === current.guidance && this._parent === parent) {
        result._cachedGuidance = this._cachedGuidance;
      } else {
        result._cachedGuidance = this._cachedGuidance.update(current.guidance, parent && parent.oneofMotionTypeCase === 1 ? parent.guidance : null);
      }
    }
    if (this._cachedBallistic && this._value._oneofMotionTypeCase === 2 && current._oneofMotionTypeCase === 2) {
      if (this._value.ballistic === current.ballistic && this._parent === parent) {
        result._cachedBallistic = this._cachedBallistic;
      } else {
        result._cachedBallistic = this._cachedBallistic.update(current.ballistic, parent && parent.oneofMotionTypeCase === 2 ? parent.ballistic : null);
      }
    }
    if (this._cachedSineWave && this._value._oneofMotionTypeCase === 3 && current._oneofMotionTypeCase === 3) {
      if (this._value.sineWave === current.sineWave && this._parent === parent) {
        result._cachedSineWave = this._cachedSineWave;
      } else {
        result._cachedSineWave = this._cachedSineWave.update(current.sineWave, parent && parent.oneofMotionTypeCase === 3 ? parent.sineWave : null);
      }
    }
    if (this._cachedOrbiting && this._value._oneofMotionTypeCase === 4 && current._oneofMotionTypeCase === 4) {
      if (this._value.orbiting === current.orbiting && this._parent === parent) {
        result._cachedOrbiting = this._cachedOrbiting;
      } else {
        result._cachedOrbiting = this._cachedOrbiting.update(current.orbiting, parent && parent.oneofMotionTypeCase === 4 ? parent.orbiting : null);
      }
    }
    return result;
  }
}
Mover_WithParent.default = new Mover_WithParent(Mover.default, null);
Mover.WithParent = Mover_WithParent;
class Mover_Descriptor {
  get guidance() {
    if (!this._guidance) {
      this._guidance = {
        name: "guidance",
        Name: "Guidance",
        number: 1,
        protoType: 11,
        protoName: "guidance",
        oneofIndex: 0,
        type: GuidanceMover,
        options: {
          comments: "Moves the missile unit linearly towards the target with tracking (like a guided missile).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guidance;
  }
  get ballistic() {
    if (!this._ballistic) {
      this._ballistic = {
        name: "ballistic",
        Name: "Ballistic",
        number: 2,
        protoType: 11,
        protoName: "ballistic",
        oneofIndex: 0,
        type: BallisticMover,
        options: {
          comments: "Moves the missile unit in a parabolic arc (like a thrown grenade).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ballistic;
  }
  get sineWave() {
    if (!this._sineWave) {
      this._sineWave = {
        name: "sineWave",
        Name: "SineWave",
        number: 3,
        protoType: 11,
        protoName: "sine_wave",
        oneofIndex: 0,
        type: SineWaveMover,
        options: {
          comments: "Moves the missile in a wave pattern towards the target with tracking.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._sineWave;
  }
  get orbiting() {
    if (!this._orbiting) {
      this._orbiting = {
        name: "orbiting",
        Name: "Orbiting",
        number: 4,
        protoType: 11,
        protoName: "orbiting",
        oneofIndex: 0,
        type: OrbitingMover,
        options: {
          comments: "Moves the missile in an orbit around the target.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._orbiting;
  }
  get upright() {
    if (!this._upright) {
      this._upright = {
        name: "upright",
        Name: "Upright",
        number: 11,
        protoType: 8,
        protoName: "upright",
        type: JsonToBoolean,
        options: {
          comments: "When enabled, forces the missile unit to maintain its original up vector (rather than following the arc of movement).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._upright;
  }
  get noRotation() {
    if (!this._noRotation) {
      this._noRotation = {
        name: "noRotation",
        Name: "NoRotation",
        number: 12,
        protoType: 8,
        protoName: "no_rotation",
        type: JsonToBoolean,
        options: {
          comments: "When enabled, forces the missile unit to maintain its original facing (rather than rotating towards the target position).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._noRotation;
  }
  get stayOnNavMesh() {
    if (!this._stayOnNavMesh) {
      this._stayOnNavMesh = {
        name: "stayOnNavMesh",
        Name: "StayOnNavMesh",
        number: 13,
        protoType: 8,
        protoName: "stay_on_nav_mesh",
        type: JsonToBoolean,
        options: {
          comments: "When enabled, attempts to keep the missile unit\'s target position inside the nav mesh. Useful for making knockback effects that respect nav mesh.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stayOnNavMesh;
  }
  get comment() {
    if (!this._comment) {
      this._comment = {
        name: "comment",
        Name: "Comment",
        number: 3000,
        protoType: 9,
        protoName: "comment",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comment;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.guidance,
        this.ballistic,
        this.sineWave,
        this.orbiting,
        this.upright,
        this.noRotation,
        this.stayOnNavMesh,
        this.comment,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofMotionType",
        Name: "OneofMotionType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUpright",
        Name: "DummyOneofForUpright",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNoRotation",
        Name: "DummyOneofForNoRotation",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStayOnNavMesh",
        Name: "DummyOneofForStayOnNavMesh",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForComment",
        Name: "DummyOneofForComment",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
Mover.descriptor = new Mover_Descriptor();
export class GuidanceMover {
  get descriptor() {
    return GuidanceMover.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAcceleration = false;
    this._acceleration = null;
    this._accelerationExpressions = [];
    this._hasAccelerationRange = false;
    this._accelerationRange = null;
    this._hasSpeed = false;
    this._speed = null;
    this._speedExpressions = [];
    this._hasSpeedRange = false;
    this._speedRange = null;
    this._hasMinSpeed = false;
    this._minSpeed = null;
    this._hasMaxSpeed = false;
    this._maxSpeed = null;
  }
  isEmpty() {
    if (this._hasAcceleration) return false;
    if (this._accelerationExpressions.length > 0) return false;
    if (this._hasAccelerationRange) return false;
    if (this._hasSpeed) return false;
    if (this._speedExpressions.length > 0) return false;
    if (this._hasSpeedRange) return false;
    if (this._hasMinSpeed) return false;
    if (this._hasMaxSpeed) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof GuidanceMover) {
      return value;
    }
    return GuidanceMover.fromJson(value);
  }
  static fromJson(json) {
    const result = new GuidanceMover();
    if (json.acceleration != null) {
      result._hasAcceleration = true;
      result._acceleration = JsonToDouble.fromJson(json.acceleration);
    }
    result._accelerationExpressions = JsonToList(json.accelerationExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.accelerationRange != null) {
      result._hasAccelerationRange = true;
      result._accelerationRange = JsonToDouble.fromJson(json.accelerationRange);
    }
    if (json.speed != null) {
      result._hasSpeed = true;
      result._speed = JsonToDouble.fromJson(json.speed);
    }
    result._speedExpressions = JsonToList(json.speedExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.speedRange != null) {
      result._hasSpeedRange = true;
      result._speedRange = JsonToDouble.fromJson(json.speedRange);
    }
    if (json.minSpeed != null) {
      result._hasMinSpeed = true;
      result._minSpeed = JsonToDouble.fromJson(json.minSpeed);
    }
    if (json.maxSpeed != null) {
      result._hasMaxSpeed = true;
      result._maxSpeed = JsonToDouble.fromJson(json.maxSpeed);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAcceleration) {
      result.acceleration = JsonToDouble.toJson(this._acceleration);
    }
    if (this._accelerationExpressions.length > 0) {
      result.accelerationExpressions = ArrayToJson(this._accelerationExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasAccelerationRange) {
      result.accelerationRange = JsonToDouble.toJson(this._accelerationRange);
    }
    if (this._hasSpeed) {
      result.speed = JsonToDouble.toJson(this._speed);
    }
    if (this._speedExpressions.length > 0) {
      result.speedExpressions = ArrayToJson(this._speedExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasSpeedRange) {
      result.speedRange = JsonToDouble.toJson(this._speedRange);
    }
    if (this._hasMinSpeed) {
      result.minSpeed = JsonToDouble.toJson(this._minSpeed);
    }
    if (this._hasMaxSpeed) {
      result.maxSpeed = JsonToDouble.toJson(this._maxSpeed);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get acceleration() {
    return this._hasAcceleration ? this._acceleration : JsonToDouble.default;
  }
  get hasAcceleration() {
    return this._hasAcceleration;
  }
  setAcceleration(path, value) {
    return {type: 'SET', path: path.concat(['acceleration']), value};
  }
  deleteAcceleration(path) {
    return {type: 'DELETE', path: path.concat(['acceleration'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get accelerationExpressions() {
    return this._accelerationExpressions;
  }
  addAccelerationExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['accelerationExpressions']), value: value.toJson()};
  }
  setAccelerationExpressions(path, value) {
    return {type: 'SET', path: path.concat(['accelerationExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setAccelerationExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['accelerationExpressions', key]), value: value.toJson()};
  }
  deleteAccelerationExpressions(path) {
    return {type: 'DELETE', path: path.concat(['accelerationExpressions'])};
  }
  deleteAccelerationExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['accelerationExpressions', key])};
  }
  /**
   * @returns {number}
   */
  get accelerationRange() {
    return this._hasAccelerationRange ? this._accelerationRange : JsonToDouble.default;
  }
  get hasAccelerationRange() {
    return this._hasAccelerationRange;
  }
  setAccelerationRange(path, value) {
    return {type: 'SET', path: path.concat(['accelerationRange']), value};
  }
  deleteAccelerationRange(path) {
    return {type: 'DELETE', path: path.concat(['accelerationRange'])};
  }
  /**
   * @returns {number}
   */
  get speed() {
    return this._hasSpeed ? this._speed : JsonToDouble.default;
  }
  get hasSpeed() {
    return this._hasSpeed;
  }
  setSpeed(path, value) {
    return {type: 'SET', path: path.concat(['speed']), value};
  }
  deleteSpeed(path) {
    return {type: 'DELETE', path: path.concat(['speed'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get speedExpressions() {
    return this._speedExpressions;
  }
  addSpeedExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['speedExpressions']), value: value.toJson()};
  }
  setSpeedExpressions(path, value) {
    return {type: 'SET', path: path.concat(['speedExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setSpeedExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['speedExpressions', key]), value: value.toJson()};
  }
  deleteSpeedExpressions(path) {
    return {type: 'DELETE', path: path.concat(['speedExpressions'])};
  }
  deleteSpeedExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['speedExpressions', key])};
  }
  /**
   * @returns {number}
   */
  get speedRange() {
    return this._hasSpeedRange ? this._speedRange : JsonToDouble.default;
  }
  get hasSpeedRange() {
    return this._hasSpeedRange;
  }
  setSpeedRange(path, value) {
    return {type: 'SET', path: path.concat(['speedRange']), value};
  }
  deleteSpeedRange(path) {
    return {type: 'DELETE', path: path.concat(['speedRange'])};
  }
  /**
   * @returns {number}
   */
  get minSpeed() {
    return this._hasMinSpeed ? this._minSpeed : JsonToDouble.default;
  }
  get hasMinSpeed() {
    return this._hasMinSpeed;
  }
  setMinSpeed(path, value) {
    return {type: 'SET', path: path.concat(['minSpeed']), value};
  }
  deleteMinSpeed(path) {
    return {type: 'DELETE', path: path.concat(['minSpeed'])};
  }
  /**
   * @returns {number}
   */
  get maxSpeed() {
    return this._hasMaxSpeed ? this._maxSpeed : JsonToDouble.default;
  }
  get hasMaxSpeed() {
    return this._hasMaxSpeed;
  }
  setMaxSpeed(path, value) {
    return {type: 'SET', path: path.concat(['maxSpeed']), value};
  }
  deleteMaxSpeed(path) {
    return {type: 'DELETE', path: path.concat(['maxSpeed'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "acceleration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GuidanceMover(this);
              copy._hasAcceleration = true;
              copy._acceleration = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAcceleration) {
                return this;
              }
              const copy = new GuidanceMover(this);
              copy._hasAcceleration = false;
              copy._acceleration = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "accelerationExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GuidanceMover(this);
              copy._accelerationExpressions = [];        for (let i of value) {
                copy._accelerationExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GuidanceMover(this);
              copy._accelerationExpressions = copy._accelerationExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._accelerationExpressions.length === 0) {
                return this;
              }
              const copy = new GuidanceMover(this);
              copy._accelerationExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._accelerationExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GuidanceMover(this);
              copy._accelerationExpressions = copy._accelerationExpressions.slice();
              copy._accelerationExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GuidanceMover(this);
              copy._accelerationExpressions = copy._accelerationExpressions.slice(0, path[1]).concat(copy._accelerationExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._accelerationExpressions.length) {
            return this;
          }
          const oldValue = this._accelerationExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GuidanceMover(this);
          copy._accelerationExpressions = copy._accelerationExpressions.slice();
          copy._accelerationExpressions[key] = newValue;
          return copy;
        }
      }
      case "accelerationRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GuidanceMover(this);
              copy._hasAccelerationRange = true;
              copy._accelerationRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAccelerationRange) {
                return this;
              }
              const copy = new GuidanceMover(this);
              copy._hasAccelerationRange = false;
              copy._accelerationRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "speed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GuidanceMover(this);
              copy._hasSpeed = true;
              copy._speed = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpeed) {
                return this;
              }
              const copy = new GuidanceMover(this);
              copy._hasSpeed = false;
              copy._speed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "speedExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GuidanceMover(this);
              copy._speedExpressions = [];        for (let i of value) {
                copy._speedExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new GuidanceMover(this);
              copy._speedExpressions = copy._speedExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._speedExpressions.length === 0) {
                return this;
              }
              const copy = new GuidanceMover(this);
              copy._speedExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._speedExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new GuidanceMover(this);
              copy._speedExpressions = copy._speedExpressions.slice();
              copy._speedExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new GuidanceMover(this);
              copy._speedExpressions = copy._speedExpressions.slice(0, path[1]).concat(copy._speedExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._speedExpressions.length) {
            return this;
          }
          const oldValue = this._speedExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new GuidanceMover(this);
          copy._speedExpressions = copy._speedExpressions.slice();
          copy._speedExpressions[key] = newValue;
          return copy;
        }
      }
      case "speedRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GuidanceMover(this);
              copy._hasSpeedRange = true;
              copy._speedRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpeedRange) {
                return this;
              }
              const copy = new GuidanceMover(this);
              copy._hasSpeedRange = false;
              copy._speedRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "minSpeed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GuidanceMover(this);
              copy._hasMinSpeed = true;
              copy._minSpeed = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMinSpeed) {
                return this;
              }
              const copy = new GuidanceMover(this);
              copy._hasMinSpeed = false;
              copy._minSpeed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxSpeed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GuidanceMover(this);
              copy._hasMaxSpeed = true;
              copy._maxSpeed = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxSpeed) {
                return this;
              }
              const copy = new GuidanceMover(this);
              copy._hasMaxSpeed = false;
              copy._maxSpeed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {GuidanceMover} other
   * @returns {GuidanceMover}
   */
  merge(other) {
    const copy = new GuidanceMover(this);
    if (other._hasAcceleration) {
      copy._hasAcceleration = true;
      copy._acceleration = other._acceleration;
    }
    copy._accelerationExpressions = this._accelerationExpressions.concat(other._accelerationExpressions);
    if (other._hasAccelerationRange) {
      copy._hasAccelerationRange = true;
      copy._accelerationRange = other._accelerationRange;
    }
    if (other._hasSpeed) {
      copy._hasSpeed = true;
      copy._speed = other._speed;
    }
    copy._speedExpressions = this._speedExpressions.concat(other._speedExpressions);
    if (other._hasSpeedRange) {
      copy._hasSpeedRange = true;
      copy._speedRange = other._speedRange;
    }
    if (other._hasMinSpeed) {
      copy._hasMinSpeed = true;
      copy._minSpeed = other._minSpeed;
    }
    if (other._hasMaxSpeed) {
      copy._hasMaxSpeed = true;
      copy._maxSpeed = other._maxSpeed;
    }
    return copy;
  }
}
GuidanceMover.default = new GuidanceMover();
class GuidanceMover_Builder {
  constructor(value) {
    this._value = new GuidanceMover(value);
  }
  build() {
    return new GuidanceMover(this._value);
  }
  setAcceleration(value) {
    this._value._hasAcceleration = true;
    this._value._acceleration = value;
    return this;
  }
  deleteAcceleration() {
    this._value._hasAcceleration = false;
    this._value._acceleration = null;
    return this;
  }
  addAllAccelerationExpressions(values) {
    this._value._accelerationExpressions = this._value._accelerationExpressions.concat(values);
    return this;
  }
  addAccelerationExpressions(value) {
    this._value._accelerationExpressions = this._value._accelerationExpressions.concat([value]);
    return this;
  }
  setAccelerationExpressions(index, value) {
    this._value._accelerationExpressions = this._value._accelerationExpressions.concat();
    this._value._accelerationExpressions[index] = value;
    return this;
  }
  clearAccelerationExpressions() {
    this._value._accelerationExpressions = [];
    return this;
  }
  setAccelerationRange(value) {
    this._value._hasAccelerationRange = true;
    this._value._accelerationRange = value;
    return this;
  }
  deleteAccelerationRange() {
    this._value._hasAccelerationRange = false;
    this._value._accelerationRange = null;
    return this;
  }
  setSpeed(value) {
    this._value._hasSpeed = true;
    this._value._speed = value;
    return this;
  }
  deleteSpeed() {
    this._value._hasSpeed = false;
    this._value._speed = null;
    return this;
  }
  addAllSpeedExpressions(values) {
    this._value._speedExpressions = this._value._speedExpressions.concat(values);
    return this;
  }
  addSpeedExpressions(value) {
    this._value._speedExpressions = this._value._speedExpressions.concat([value]);
    return this;
  }
  setSpeedExpressions(index, value) {
    this._value._speedExpressions = this._value._speedExpressions.concat();
    this._value._speedExpressions[index] = value;
    return this;
  }
  clearSpeedExpressions() {
    this._value._speedExpressions = [];
    return this;
  }
  setSpeedRange(value) {
    this._value._hasSpeedRange = true;
    this._value._speedRange = value;
    return this;
  }
  deleteSpeedRange() {
    this._value._hasSpeedRange = false;
    this._value._speedRange = null;
    return this;
  }
  setMinSpeed(value) {
    this._value._hasMinSpeed = true;
    this._value._minSpeed = value;
    return this;
  }
  deleteMinSpeed() {
    this._value._hasMinSpeed = false;
    this._value._minSpeed = null;
    return this;
  }
  setMaxSpeed(value) {
    this._value._hasMaxSpeed = true;
    this._value._maxSpeed = value;
    return this;
  }
  deleteMaxSpeed() {
    this._value._hasMaxSpeed = false;
    this._value._maxSpeed = null;
    return this;
  }
}
GuidanceMover.Builder = GuidanceMover_Builder;
class GuidanceMover_WithParent {
  /**
   * @param {GuidanceMover} value
   * @param {GuidanceMover_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return GuidanceMover.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAcceleration() {
    if (this._cachedHasAcceleration === undefined) {
      if (this._value.hasAcceleration) {
        this._cachedHasAcceleration = true;
      } else {
        this._cachedHasAcceleration = this._parent ? this._parent.hasAcceleration : false;
      }
    }
    return this._cachedHasAcceleration;
  }
  get acceleration() {
    if (this._cachedAcceleration === undefined) {
      if (this._value.hasAcceleration) {
        this._cachedAcceleration = this._value.acceleration;
      } else {
        this._cachedAcceleration = this._parent ? this._parent.acceleration : this._value.acceleration;
      }
    }
    return this._cachedAcceleration;
  }
  get selfAccelerationExpressions() {
    if (!this._selfAccelerationExpressions) {
      this._selfAccelerationExpressions = [];
      for (let i of this._value.accelerationExpressions) {
        this._selfAccelerationExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfAccelerationExpressions;
  }
  get inherentAccelerationExpressions() {
    if (!this._inherentAccelerationExpressions) {
      this._inherentAccelerationExpressions = this._parent ? this._parent.accelerationExpressions : [];
    }
    return this._inherentAccelerationExpressions;
  }
  get accelerationExpressions() {
    if (!this._allAccelerationExpressions) {
      this._allAccelerationExpressions = this._parent ? this._parent.accelerationExpressions.concat(this.selfAccelerationExpressions) : this.selfAccelerationExpressions;
    }
    return this._allAccelerationExpressions;
  }
  get hasAccelerationRange() {
    if (this._cachedHasAccelerationRange === undefined) {
      if (this._value.hasAccelerationRange) {
        this._cachedHasAccelerationRange = true;
      } else {
        this._cachedHasAccelerationRange = this._parent ? this._parent.hasAccelerationRange : false;
      }
    }
    return this._cachedHasAccelerationRange;
  }
  get accelerationRange() {
    if (this._cachedAccelerationRange === undefined) {
      if (this._value.hasAccelerationRange) {
        this._cachedAccelerationRange = this._value.accelerationRange;
      } else {
        this._cachedAccelerationRange = this._parent ? this._parent.accelerationRange : this._value.accelerationRange;
      }
    }
    return this._cachedAccelerationRange;
  }
  get hasSpeed() {
    if (this._cachedHasSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedHasSpeed = true;
      } else {
        this._cachedHasSpeed = this._parent ? this._parent.hasSpeed : false;
      }
    }
    return this._cachedHasSpeed;
  }
  get speed() {
    if (this._cachedSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedSpeed = this._value.speed;
      } else {
        this._cachedSpeed = this._parent ? this._parent.speed : this._value.speed;
      }
    }
    return this._cachedSpeed;
  }
  get selfSpeedExpressions() {
    if (!this._selfSpeedExpressions) {
      this._selfSpeedExpressions = [];
      for (let i of this._value.speedExpressions) {
        this._selfSpeedExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfSpeedExpressions;
  }
  get inherentSpeedExpressions() {
    if (!this._inherentSpeedExpressions) {
      this._inherentSpeedExpressions = this._parent ? this._parent.speedExpressions : [];
    }
    return this._inherentSpeedExpressions;
  }
  get speedExpressions() {
    if (!this._allSpeedExpressions) {
      this._allSpeedExpressions = this._parent ? this._parent.speedExpressions.concat(this.selfSpeedExpressions) : this.selfSpeedExpressions;
    }
    return this._allSpeedExpressions;
  }
  get hasSpeedRange() {
    if (this._cachedHasSpeedRange === undefined) {
      if (this._value.hasSpeedRange) {
        this._cachedHasSpeedRange = true;
      } else {
        this._cachedHasSpeedRange = this._parent ? this._parent.hasSpeedRange : false;
      }
    }
    return this._cachedHasSpeedRange;
  }
  get speedRange() {
    if (this._cachedSpeedRange === undefined) {
      if (this._value.hasSpeedRange) {
        this._cachedSpeedRange = this._value.speedRange;
      } else {
        this._cachedSpeedRange = this._parent ? this._parent.speedRange : this._value.speedRange;
      }
    }
    return this._cachedSpeedRange;
  }
  get hasMinSpeed() {
    if (this._cachedHasMinSpeed === undefined) {
      if (this._value.hasMinSpeed) {
        this._cachedHasMinSpeed = true;
      } else {
        this._cachedHasMinSpeed = this._parent ? this._parent.hasMinSpeed : false;
      }
    }
    return this._cachedHasMinSpeed;
  }
  get minSpeed() {
    if (this._cachedMinSpeed === undefined) {
      if (this._value.hasMinSpeed) {
        this._cachedMinSpeed = this._value.minSpeed;
      } else {
        this._cachedMinSpeed = this._parent ? this._parent.minSpeed : this._value.minSpeed;
      }
    }
    return this._cachedMinSpeed;
  }
  get hasMaxSpeed() {
    if (this._cachedHasMaxSpeed === undefined) {
      if (this._value.hasMaxSpeed) {
        this._cachedHasMaxSpeed = true;
      } else {
        this._cachedHasMaxSpeed = this._parent ? this._parent.hasMaxSpeed : false;
      }
    }
    return this._cachedHasMaxSpeed;
  }
  get maxSpeed() {
    if (this._cachedMaxSpeed === undefined) {
      if (this._value.hasMaxSpeed) {
        this._cachedMaxSpeed = this._value.maxSpeed;
      } else {
        this._cachedMaxSpeed = this._parent ? this._parent.maxSpeed : this._value.maxSpeed;
      }
    }
    return this._cachedMaxSpeed;
  }
  update(current, parent) {
    const result = new GuidanceMover_WithParent(current, parent);
    if (this._selfAccelerationExpressions) {
      if (this._value.accelerationExpressions === current.accelerationExpressions) {
        result._selfAccelerationExpressions = this._selfAccelerationExpressions;
      } else {
        result._selfAccelerationExpressions = [];
        for (let i = 0; i < current.accelerationExpressions.length; i++) {
          const oldValue = this._value.accelerationExpressions[i];
          if (oldValue) {
            const oldCache = this._selfAccelerationExpressions[i];
            if (oldValue === current.accelerationExpressions[i]) {
              result._selfAccelerationExpressions[i] = oldCache;
            } else {
              result._selfAccelerationExpressions[i] = oldCache.update(current.accelerationExpressions[i], null);
            }
          } else {
            result._selfAccelerationExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.accelerationExpressions[i], null);
          }
        }
      }
    }
    if (this._selfSpeedExpressions) {
      if (this._value.speedExpressions === current.speedExpressions) {
        result._selfSpeedExpressions = this._selfSpeedExpressions;
      } else {
        result._selfSpeedExpressions = [];
        for (let i = 0; i < current.speedExpressions.length; i++) {
          const oldValue = this._value.speedExpressions[i];
          if (oldValue) {
            const oldCache = this._selfSpeedExpressions[i];
            if (oldValue === current.speedExpressions[i]) {
              result._selfSpeedExpressions[i] = oldCache;
            } else {
              result._selfSpeedExpressions[i] = oldCache.update(current.speedExpressions[i], null);
            }
          } else {
            result._selfSpeedExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.speedExpressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
GuidanceMover_WithParent.default = new GuidanceMover_WithParent(GuidanceMover.default, null);
GuidanceMover.WithParent = GuidanceMover_WithParent;
class GuidanceMover_Descriptor {
  get acceleration() {
    if (!this._acceleration) {
      this._acceleration = {
        name: "acceleration",
        Name: "Acceleration",
        number: 11,
        protoType: 1,
        protoName: "acceleration",
        type: JsonToDouble,
        options: {
          comments: "This value is added to the missile unit\'s speed each second.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._acceleration;
  }
  get accelerationExpressions() {
    if (!this._accelerationExpressions) {
      this._accelerationExpressions = {
        name: "accelerationExpressions",
        Name: "AccelerationExpressions",
        number: 17,
        protoType: 11,
        protoName: "acceleration_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "If set, the evaluated expression will be added to the acceleration when the missile unit is launched.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._accelerationExpressions;
  }
  get accelerationRange() {
    if (!this._accelerationRange) {
      this._accelerationRange = {
        name: "accelerationRange",
        Name: "AccelerationRange",
        number: 12,
        protoType: 1,
        protoName: "acceleration_range",
        type: JsonToDouble,
        options: {
          comments: "A random value between 0 and this value is added to the missile unit\'s acceleration.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._accelerationRange;
  }
  get speed() {
    if (!this._speed) {
      this._speed = {
        name: "speed",
        Name: "Speed",
        number: 13,
        protoType: 1,
        protoName: "speed",
        type: JsonToDouble,
        options: {
          comments: "The missile unit\'s initial speed, in terrain grid-units-per-second.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speed;
  }
  get speedExpressions() {
    if (!this._speedExpressions) {
      this._speedExpressions = {
        name: "speedExpressions",
        Name: "SpeedExpressions",
        number: 18,
        protoType: 11,
        protoName: "speed_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "If set, the evaluated expression will be added to the speed when the missile unit is launched.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speedExpressions;
  }
  get speedRange() {
    if (!this._speedRange) {
      this._speedRange = {
        name: "speedRange",
        Name: "SpeedRange",
        number: 14,
        protoType: 1,
        protoName: "speed_range",
        type: JsonToDouble,
        options: {
          comments: "A random value between 0 and this value is added to the missile unit\'s speed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speedRange;
  }
  get minSpeed() {
    if (!this._minSpeed) {
      this._minSpeed = {
        name: "minSpeed",
        Name: "MinSpeed",
        number: 15,
        protoType: 1,
        protoName: "min_speed",
        type: JsonToDouble,
        options: {
          comments: "The minimum speed the missile unit can move.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._minSpeed;
  }
  get maxSpeed() {
    if (!this._maxSpeed) {
      this._maxSpeed = {
        name: "maxSpeed",
        Name: "MaxSpeed",
        number: 16,
        protoType: 1,
        protoName: "max_speed",
        type: JsonToDouble,
        options: {
          comments: "The maximum speed the missile unit can move. Note that this needs to be above 0 for the missile unit to go anywhere.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxSpeed;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.acceleration,
        this.accelerationExpressions,
        this.accelerationRange,
        this.speed,
        this.speedExpressions,
        this.speedRange,
        this.minSpeed,
        this.maxSpeed,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAcceleration",
        Name: "DummyOneofForAcceleration",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAccelerationRange",
        Name: "DummyOneofForAccelerationRange",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpeed",
        Name: "DummyOneofForSpeed",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpeedRange",
        Name: "DummyOneofForSpeedRange",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMinSpeed",
        Name: "DummyOneofForMinSpeed",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxSpeed",
        Name: "DummyOneofForMaxSpeed",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
GuidanceMover.descriptor = new GuidanceMover_Descriptor();
export class BallisticMover {
  get descriptor() {
    return BallisticMover.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasFlightTime = false;
    this._flightTime = null;
    this._flightTimeExpressions = [];
    this._hasFlightTimeRange = false;
    this._flightTimeRange = null;
    this._hasSpeed = false;
    this._speed = null;
    this._speedExpressions = [];
    this._hasSpeedRange = false;
    this._speedRange = null;
    this._hasGravity = false;
    this._gravity = null;
  }
  isEmpty() {
    if (this._hasFlightTime) return false;
    if (this._flightTimeExpressions.length > 0) return false;
    if (this._hasFlightTimeRange) return false;
    if (this._hasSpeed) return false;
    if (this._speedExpressions.length > 0) return false;
    if (this._hasSpeedRange) return false;
    if (this._hasGravity) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof BallisticMover) {
      return value;
    }
    return BallisticMover.fromJson(value);
  }
  static fromJson(json) {
    const result = new BallisticMover();
    if (json.flightTime != null) {
      result._hasFlightTime = true;
      result._flightTime = JsonToDouble.fromJson(json.flightTime);
    }
    result._flightTimeExpressions = JsonToList(json.flightTimeExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.flightTimeRange != null) {
      result._hasFlightTimeRange = true;
      result._flightTimeRange = JsonToDouble.fromJson(json.flightTimeRange);
    }
    if (json.speed != null) {
      result._hasSpeed = true;
      result._speed = JsonToDouble.fromJson(json.speed);
    }
    result._speedExpressions = JsonToList(json.speedExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    if (json.speedRange != null) {
      result._hasSpeedRange = true;
      result._speedRange = JsonToDouble.fromJson(json.speedRange);
    }
    if (json.gravity != null) {
      result._hasGravity = true;
      result._gravity = JsonToDouble.fromJson(json.gravity);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasFlightTime) {
      result.flightTime = JsonToDouble.toJson(this._flightTime);
    }
    if (this._flightTimeExpressions.length > 0) {
      result.flightTimeExpressions = ArrayToJson(this._flightTimeExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasFlightTimeRange) {
      result.flightTimeRange = JsonToDouble.toJson(this._flightTimeRange);
    }
    if (this._hasSpeed) {
      result.speed = JsonToDouble.toJson(this._speed);
    }
    if (this._speedExpressions.length > 0) {
      result.speedExpressions = ArrayToJson(this._speedExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (this._hasSpeedRange) {
      result.speedRange = JsonToDouble.toJson(this._speedRange);
    }
    if (this._hasGravity) {
      result.gravity = JsonToDouble.toJson(this._gravity);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get flightTime() {
    return this._hasFlightTime ? this._flightTime : JsonToDouble.default;
  }
  get hasFlightTime() {
    return this._hasFlightTime;
  }
  setFlightTime(path, value) {
    return {type: 'SET', path: path.concat(['flightTime']), value};
  }
  deleteFlightTime(path) {
    return {type: 'DELETE', path: path.concat(['flightTime'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get flightTimeExpressions() {
    return this._flightTimeExpressions;
  }
  addFlightTimeExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['flightTimeExpressions']), value: value.toJson()};
  }
  setFlightTimeExpressions(path, value) {
    return {type: 'SET', path: path.concat(['flightTimeExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setFlightTimeExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['flightTimeExpressions', key]), value: value.toJson()};
  }
  deleteFlightTimeExpressions(path) {
    return {type: 'DELETE', path: path.concat(['flightTimeExpressions'])};
  }
  deleteFlightTimeExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['flightTimeExpressions', key])};
  }
  /**
   * @returns {number}
   */
  get flightTimeRange() {
    return this._hasFlightTimeRange ? this._flightTimeRange : JsonToDouble.default;
  }
  get hasFlightTimeRange() {
    return this._hasFlightTimeRange;
  }
  setFlightTimeRange(path, value) {
    return {type: 'SET', path: path.concat(['flightTimeRange']), value};
  }
  deleteFlightTimeRange(path) {
    return {type: 'DELETE', path: path.concat(['flightTimeRange'])};
  }
  /**
   * @returns {number}
   */
  get speed() {
    return this._hasSpeed ? this._speed : JsonToDouble.default;
  }
  get hasSpeed() {
    return this._hasSpeed;
  }
  setSpeed(path, value) {
    return {type: 'SET', path: path.concat(['speed']), value};
  }
  deleteSpeed(path) {
    return {type: 'DELETE', path: path.concat(['speed'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get speedExpressions() {
    return this._speedExpressions;
  }
  addSpeedExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['speedExpressions']), value: value.toJson()};
  }
  setSpeedExpressions(path, value) {
    return {type: 'SET', path: path.concat(['speedExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setSpeedExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['speedExpressions', key]), value: value.toJson()};
  }
  deleteSpeedExpressions(path) {
    return {type: 'DELETE', path: path.concat(['speedExpressions'])};
  }
  deleteSpeedExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['speedExpressions', key])};
  }
  /**
   * @returns {number}
   */
  get speedRange() {
    return this._hasSpeedRange ? this._speedRange : JsonToDouble.default;
  }
  get hasSpeedRange() {
    return this._hasSpeedRange;
  }
  setSpeedRange(path, value) {
    return {type: 'SET', path: path.concat(['speedRange']), value};
  }
  deleteSpeedRange(path) {
    return {type: 'DELETE', path: path.concat(['speedRange'])};
  }
  /**
   * @returns {number}
   */
  get gravity() {
    return this._hasGravity ? this._gravity : JsonToDouble.default;
  }
  get hasGravity() {
    return this._hasGravity;
  }
  setGravity(path, value) {
    return {type: 'SET', path: path.concat(['gravity']), value};
  }
  deleteGravity(path) {
    return {type: 'DELETE', path: path.concat(['gravity'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "flightTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BallisticMover(this);
              copy._hasFlightTime = true;
              copy._flightTime = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFlightTime) {
                return this;
              }
              const copy = new BallisticMover(this);
              copy._hasFlightTime = false;
              copy._flightTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "flightTimeExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BallisticMover(this);
              copy._flightTimeExpressions = [];        for (let i of value) {
                copy._flightTimeExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BallisticMover(this);
              copy._flightTimeExpressions = copy._flightTimeExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._flightTimeExpressions.length === 0) {
                return this;
              }
              const copy = new BallisticMover(this);
              copy._flightTimeExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._flightTimeExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BallisticMover(this);
              copy._flightTimeExpressions = copy._flightTimeExpressions.slice();
              copy._flightTimeExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BallisticMover(this);
              copy._flightTimeExpressions = copy._flightTimeExpressions.slice(0, path[1]).concat(copy._flightTimeExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._flightTimeExpressions.length) {
            return this;
          }
          const oldValue = this._flightTimeExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BallisticMover(this);
          copy._flightTimeExpressions = copy._flightTimeExpressions.slice();
          copy._flightTimeExpressions[key] = newValue;
          return copy;
        }
      }
      case "flightTimeRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BallisticMover(this);
              copy._hasFlightTimeRange = true;
              copy._flightTimeRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFlightTimeRange) {
                return this;
              }
              const copy = new BallisticMover(this);
              copy._hasFlightTimeRange = false;
              copy._flightTimeRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "speed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BallisticMover(this);
              copy._hasSpeed = true;
              copy._speed = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpeed) {
                return this;
              }
              const copy = new BallisticMover(this);
              copy._hasSpeed = false;
              copy._speed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "speedExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BallisticMover(this);
              copy._speedExpressions = [];        for (let i of value) {
                copy._speedExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new BallisticMover(this);
              copy._speedExpressions = copy._speedExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._speedExpressions.length === 0) {
                return this;
              }
              const copy = new BallisticMover(this);
              copy._speedExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._speedExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new BallisticMover(this);
              copy._speedExpressions = copy._speedExpressions.slice();
              copy._speedExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new BallisticMover(this);
              copy._speedExpressions = copy._speedExpressions.slice(0, path[1]).concat(copy._speedExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._speedExpressions.length) {
            return this;
          }
          const oldValue = this._speedExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new BallisticMover(this);
          copy._speedExpressions = copy._speedExpressions.slice();
          copy._speedExpressions[key] = newValue;
          return copy;
        }
      }
      case "speedRange": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BallisticMover(this);
              copy._hasSpeedRange = true;
              copy._speedRange = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpeedRange) {
                return this;
              }
              const copy = new BallisticMover(this);
              copy._hasSpeedRange = false;
              copy._speedRange = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gravity": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new BallisticMover(this);
              copy._hasGravity = true;
              copy._gravity = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGravity) {
                return this;
              }
              const copy = new BallisticMover(this);
              copy._hasGravity = false;
              copy._gravity = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {BallisticMover} other
   * @returns {BallisticMover}
   */
  merge(other) {
    const copy = new BallisticMover(this);
    if (other._hasFlightTime) {
      copy._hasFlightTime = true;
      copy._flightTime = other._flightTime;
    }
    copy._flightTimeExpressions = this._flightTimeExpressions.concat(other._flightTimeExpressions);
    if (other._hasFlightTimeRange) {
      copy._hasFlightTimeRange = true;
      copy._flightTimeRange = other._flightTimeRange;
    }
    if (other._hasSpeed) {
      copy._hasSpeed = true;
      copy._speed = other._speed;
    }
    copy._speedExpressions = this._speedExpressions.concat(other._speedExpressions);
    if (other._hasSpeedRange) {
      copy._hasSpeedRange = true;
      copy._speedRange = other._speedRange;
    }
    if (other._hasGravity) {
      copy._hasGravity = true;
      copy._gravity = other._gravity;
    }
    return copy;
  }
}
BallisticMover.default = new BallisticMover();
class BallisticMover_Builder {
  constructor(value) {
    this._value = new BallisticMover(value);
  }
  build() {
    return new BallisticMover(this._value);
  }
  setFlightTime(value) {
    this._value._hasFlightTime = true;
    this._value._flightTime = value;
    return this;
  }
  deleteFlightTime() {
    this._value._hasFlightTime = false;
    this._value._flightTime = null;
    return this;
  }
  addAllFlightTimeExpressions(values) {
    this._value._flightTimeExpressions = this._value._flightTimeExpressions.concat(values);
    return this;
  }
  addFlightTimeExpressions(value) {
    this._value._flightTimeExpressions = this._value._flightTimeExpressions.concat([value]);
    return this;
  }
  setFlightTimeExpressions(index, value) {
    this._value._flightTimeExpressions = this._value._flightTimeExpressions.concat();
    this._value._flightTimeExpressions[index] = value;
    return this;
  }
  clearFlightTimeExpressions() {
    this._value._flightTimeExpressions = [];
    return this;
  }
  setFlightTimeRange(value) {
    this._value._hasFlightTimeRange = true;
    this._value._flightTimeRange = value;
    return this;
  }
  deleteFlightTimeRange() {
    this._value._hasFlightTimeRange = false;
    this._value._flightTimeRange = null;
    return this;
  }
  setSpeed(value) {
    this._value._hasSpeed = true;
    this._value._speed = value;
    return this;
  }
  deleteSpeed() {
    this._value._hasSpeed = false;
    this._value._speed = null;
    return this;
  }
  addAllSpeedExpressions(values) {
    this._value._speedExpressions = this._value._speedExpressions.concat(values);
    return this;
  }
  addSpeedExpressions(value) {
    this._value._speedExpressions = this._value._speedExpressions.concat([value]);
    return this;
  }
  setSpeedExpressions(index, value) {
    this._value._speedExpressions = this._value._speedExpressions.concat();
    this._value._speedExpressions[index] = value;
    return this;
  }
  clearSpeedExpressions() {
    this._value._speedExpressions = [];
    return this;
  }
  setSpeedRange(value) {
    this._value._hasSpeedRange = true;
    this._value._speedRange = value;
    return this;
  }
  deleteSpeedRange() {
    this._value._hasSpeedRange = false;
    this._value._speedRange = null;
    return this;
  }
  setGravity(value) {
    this._value._hasGravity = true;
    this._value._gravity = value;
    return this;
  }
  deleteGravity() {
    this._value._hasGravity = false;
    this._value._gravity = null;
    return this;
  }
}
BallisticMover.Builder = BallisticMover_Builder;
class BallisticMover_WithParent {
  /**
   * @param {BallisticMover} value
   * @param {BallisticMover_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return BallisticMover.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasFlightTime() {
    if (this._cachedHasFlightTime === undefined) {
      if (this._value.hasFlightTime) {
        this._cachedHasFlightTime = true;
      } else {
        this._cachedHasFlightTime = this._parent ? this._parent.hasFlightTime : false;
      }
    }
    return this._cachedHasFlightTime;
  }
  get flightTime() {
    if (this._cachedFlightTime === undefined) {
      if (this._value.hasFlightTime) {
        this._cachedFlightTime = this._value.flightTime;
      } else {
        this._cachedFlightTime = this._parent ? this._parent.flightTime : this._value.flightTime;
      }
    }
    return this._cachedFlightTime;
  }
  get selfFlightTimeExpressions() {
    if (!this._selfFlightTimeExpressions) {
      this._selfFlightTimeExpressions = [];
      for (let i of this._value.flightTimeExpressions) {
        this._selfFlightTimeExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfFlightTimeExpressions;
  }
  get inherentFlightTimeExpressions() {
    if (!this._inherentFlightTimeExpressions) {
      this._inherentFlightTimeExpressions = this._parent ? this._parent.flightTimeExpressions : [];
    }
    return this._inherentFlightTimeExpressions;
  }
  get flightTimeExpressions() {
    if (!this._allFlightTimeExpressions) {
      this._allFlightTimeExpressions = this._parent ? this._parent.flightTimeExpressions.concat(this.selfFlightTimeExpressions) : this.selfFlightTimeExpressions;
    }
    return this._allFlightTimeExpressions;
  }
  get hasFlightTimeRange() {
    if (this._cachedHasFlightTimeRange === undefined) {
      if (this._value.hasFlightTimeRange) {
        this._cachedHasFlightTimeRange = true;
      } else {
        this._cachedHasFlightTimeRange = this._parent ? this._parent.hasFlightTimeRange : false;
      }
    }
    return this._cachedHasFlightTimeRange;
  }
  get flightTimeRange() {
    if (this._cachedFlightTimeRange === undefined) {
      if (this._value.hasFlightTimeRange) {
        this._cachedFlightTimeRange = this._value.flightTimeRange;
      } else {
        this._cachedFlightTimeRange = this._parent ? this._parent.flightTimeRange : this._value.flightTimeRange;
      }
    }
    return this._cachedFlightTimeRange;
  }
  get hasSpeed() {
    if (this._cachedHasSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedHasSpeed = true;
      } else {
        this._cachedHasSpeed = this._parent ? this._parent.hasSpeed : false;
      }
    }
    return this._cachedHasSpeed;
  }
  get speed() {
    if (this._cachedSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedSpeed = this._value.speed;
      } else {
        this._cachedSpeed = this._parent ? this._parent.speed : this._value.speed;
      }
    }
    return this._cachedSpeed;
  }
  get selfSpeedExpressions() {
    if (!this._selfSpeedExpressions) {
      this._selfSpeedExpressions = [];
      for (let i of this._value.speedExpressions) {
        this._selfSpeedExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfSpeedExpressions;
  }
  get inherentSpeedExpressions() {
    if (!this._inherentSpeedExpressions) {
      this._inherentSpeedExpressions = this._parent ? this._parent.speedExpressions : [];
    }
    return this._inherentSpeedExpressions;
  }
  get speedExpressions() {
    if (!this._allSpeedExpressions) {
      this._allSpeedExpressions = this._parent ? this._parent.speedExpressions.concat(this.selfSpeedExpressions) : this.selfSpeedExpressions;
    }
    return this._allSpeedExpressions;
  }
  get hasSpeedRange() {
    if (this._cachedHasSpeedRange === undefined) {
      if (this._value.hasSpeedRange) {
        this._cachedHasSpeedRange = true;
      } else {
        this._cachedHasSpeedRange = this._parent ? this._parent.hasSpeedRange : false;
      }
    }
    return this._cachedHasSpeedRange;
  }
  get speedRange() {
    if (this._cachedSpeedRange === undefined) {
      if (this._value.hasSpeedRange) {
        this._cachedSpeedRange = this._value.speedRange;
      } else {
        this._cachedSpeedRange = this._parent ? this._parent.speedRange : this._value.speedRange;
      }
    }
    return this._cachedSpeedRange;
  }
  get hasGravity() {
    if (this._cachedHasGravity === undefined) {
      if (this._value.hasGravity) {
        this._cachedHasGravity = true;
      } else {
        this._cachedHasGravity = this._parent ? this._parent.hasGravity : false;
      }
    }
    return this._cachedHasGravity;
  }
  get gravity() {
    if (this._cachedGravity === undefined) {
      if (this._value.hasGravity) {
        this._cachedGravity = this._value.gravity;
      } else {
        this._cachedGravity = this._parent ? this._parent.gravity : this._value.gravity;
      }
    }
    return this._cachedGravity;
  }
  update(current, parent) {
    const result = new BallisticMover_WithParent(current, parent);
    if (this._selfFlightTimeExpressions) {
      if (this._value.flightTimeExpressions === current.flightTimeExpressions) {
        result._selfFlightTimeExpressions = this._selfFlightTimeExpressions;
      } else {
        result._selfFlightTimeExpressions = [];
        for (let i = 0; i < current.flightTimeExpressions.length; i++) {
          const oldValue = this._value.flightTimeExpressions[i];
          if (oldValue) {
            const oldCache = this._selfFlightTimeExpressions[i];
            if (oldValue === current.flightTimeExpressions[i]) {
              result._selfFlightTimeExpressions[i] = oldCache;
            } else {
              result._selfFlightTimeExpressions[i] = oldCache.update(current.flightTimeExpressions[i], null);
            }
          } else {
            result._selfFlightTimeExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.flightTimeExpressions[i], null);
          }
        }
      }
    }
    if (this._selfSpeedExpressions) {
      if (this._value.speedExpressions === current.speedExpressions) {
        result._selfSpeedExpressions = this._selfSpeedExpressions;
      } else {
        result._selfSpeedExpressions = [];
        for (let i = 0; i < current.speedExpressions.length; i++) {
          const oldValue = this._value.speedExpressions[i];
          if (oldValue) {
            const oldCache = this._selfSpeedExpressions[i];
            if (oldValue === current.speedExpressions[i]) {
              result._selfSpeedExpressions[i] = oldCache;
            } else {
              result._selfSpeedExpressions[i] = oldCache.update(current.speedExpressions[i], null);
            }
          } else {
            result._selfSpeedExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.speedExpressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
BallisticMover_WithParent.default = new BallisticMover_WithParent(BallisticMover.default, null);
BallisticMover.WithParent = BallisticMover_WithParent;
class BallisticMover_Descriptor {
  get flightTime() {
    if (!this._flightTime) {
      this._flightTime = {
        name: "flightTime",
        Name: "FlightTime",
        number: 1,
        protoType: 1,
        protoName: "flight_time",
        type: JsonToDouble,
        options: {
          comments: "When set, the missile unit\'s speed will be adjusted so that it takes this time to reach its target, regardless of the distance. When using flight time, speed should be set to 0.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._flightTime;
  }
  get flightTimeExpressions() {
    if (!this._flightTimeExpressions) {
      this._flightTimeExpressions = {
        name: "flightTimeExpressions",
        Name: "FlightTimeExpressions",
        number: 6,
        protoType: 11,
        protoName: "flight_time_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "If set, the evaluated expression will be added to the flight time when the missile unit is launched.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._flightTimeExpressions;
  }
  get flightTimeRange() {
    if (!this._flightTimeRange) {
      this._flightTimeRange = {
        name: "flightTimeRange",
        Name: "FlightTimeRange",
        number: 2,
        protoType: 1,
        protoName: "flight_time_range",
        type: JsonToDouble,
        options: {
          comments: "A random value between 0 and this value is added to the missile unit\'s flight time.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._flightTimeRange;
  }
  get speed() {
    if (!this._speed) {
      this._speed = {
        name: "speed",
        Name: "Speed",
        number: 4,
        protoType: 1,
        protoName: "speed",
        type: JsonToDouble,
        options: {
          comments: "Speed of the mover. When using speed, flight time should be set to 0. Speed is measured in terrain grid-units-per-second.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speed;
  }
  get speedExpressions() {
    if (!this._speedExpressions) {
      this._speedExpressions = {
        name: "speedExpressions",
        Name: "SpeedExpressions",
        number: 7,
        protoType: 11,
        protoName: "speed_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "If set, the evaluated expression will be added to the speed when the missile unit is launched.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speedExpressions;
  }
  get speedRange() {
    if (!this._speedRange) {
      this._speedRange = {
        name: "speedRange",
        Name: "SpeedRange",
        number: 5,
        protoType: 1,
        protoName: "speed_range",
        type: JsonToDouble,
        options: {
          comments: "A random value between 0 and this value is added to the missile unit\'s speed.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speedRange;
  }
  get gravity() {
    if (!this._gravity) {
      this._gravity = {
        name: "gravity",
        Name: "Gravity",
        number: 3,
        protoType: 1,
        protoName: "gravity",
        type: JsonToDouble,
        options: {
          comments: "Used to determine the height of the arc. Higher values mean a higher arc.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gravity;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.flightTime,
        this.flightTimeExpressions,
        this.flightTimeRange,
        this.speed,
        this.speedExpressions,
        this.speedRange,
        this.gravity,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForFlightTime",
        Name: "DummyOneofForFlightTime",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFlightTimeRange",
        Name: "DummyOneofForFlightTimeRange",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpeed",
        Name: "DummyOneofForSpeed",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpeedRange",
        Name: "DummyOneofForSpeedRange",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGravity",
        Name: "DummyOneofForGravity",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
BallisticMover.descriptor = new BallisticMover_Descriptor();
export class SineWaveMover {
  get descriptor() {
    return SineWaveMover.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAmplitude = false;
    this._amplitude = null;
    this._hasPeakCount = false;
    this._peakCount = null;
    this._hasSpeed = false;
    this._speed = null;
    this._speedExpressions = [];
  }
  isEmpty() {
    if (this._hasAmplitude) return false;
    if (this._hasPeakCount) return false;
    if (this._hasSpeed) return false;
    if (this._speedExpressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SineWaveMover) {
      return value;
    }
    return SineWaveMover.fromJson(value);
  }
  static fromJson(json) {
    const result = new SineWaveMover();
    if (json.amplitude != null) {
      result._hasAmplitude = true;
      result._amplitude = JsonToDouble.fromJson(json.amplitude);
    }
    if (json.peakCount != null) {
      result._hasPeakCount = true;
      result._peakCount = JsonToInt32.fromJson(json.peakCount);
    }
    if (json.speed != null) {
      result._hasSpeed = true;
      result._speed = JsonToDouble.fromJson(json.speed);
    }
    result._speedExpressions = JsonToList(json.speedExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAmplitude) {
      result.amplitude = JsonToDouble.toJson(this._amplitude);
    }
    if (this._hasPeakCount) {
      result.peakCount = JsonToInt32.toJson(this._peakCount);
    }
    if (this._hasSpeed) {
      result.speed = JsonToDouble.toJson(this._speed);
    }
    if (this._speedExpressions.length > 0) {
      result.speedExpressions = ArrayToJson(this._speedExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get amplitude() {
    return this._hasAmplitude ? this._amplitude : JsonToDouble.default;
  }
  get hasAmplitude() {
    return this._hasAmplitude;
  }
  setAmplitude(path, value) {
    return {type: 'SET', path: path.concat(['amplitude']), value};
  }
  deleteAmplitude(path) {
    return {type: 'DELETE', path: path.concat(['amplitude'])};
  }
  /**
   * @returns {number}
   */
  get peakCount() {
    return this._hasPeakCount ? this._peakCount : JsonToInt32.default;
  }
  get hasPeakCount() {
    return this._hasPeakCount;
  }
  setPeakCount(path, value) {
    return {type: 'SET', path: path.concat(['peakCount']), value};
  }
  deletePeakCount(path) {
    return {type: 'DELETE', path: path.concat(['peakCount'])};
  }
  /**
   * @returns {number}
   */
  get speed() {
    return this._hasSpeed ? this._speed : JsonToDouble.default;
  }
  get hasSpeed() {
    return this._hasSpeed;
  }
  setSpeed(path, value) {
    return {type: 'SET', path: path.concat(['speed']), value};
  }
  deleteSpeed(path) {
    return {type: 'DELETE', path: path.concat(['speed'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get speedExpressions() {
    return this._speedExpressions;
  }
  addSpeedExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['speedExpressions']), value: value.toJson()};
  }
  setSpeedExpressions(path, value) {
    return {type: 'SET', path: path.concat(['speedExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setSpeedExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['speedExpressions', key]), value: value.toJson()};
  }
  deleteSpeedExpressions(path) {
    return {type: 'DELETE', path: path.concat(['speedExpressions'])};
  }
  deleteSpeedExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['speedExpressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "amplitude": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SineWaveMover(this);
              copy._hasAmplitude = true;
              copy._amplitude = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmplitude) {
                return this;
              }
              const copy = new SineWaveMover(this);
              copy._hasAmplitude = false;
              copy._amplitude = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "peakCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SineWaveMover(this);
              copy._hasPeakCount = true;
              copy._peakCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPeakCount) {
                return this;
              }
              const copy = new SineWaveMover(this);
              copy._hasPeakCount = false;
              copy._peakCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "speed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SineWaveMover(this);
              copy._hasSpeed = true;
              copy._speed = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpeed) {
                return this;
              }
              const copy = new SineWaveMover(this);
              copy._hasSpeed = false;
              copy._speed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "speedExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SineWaveMover(this);
              copy._speedExpressions = [];        for (let i of value) {
                copy._speedExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new SineWaveMover(this);
              copy._speedExpressions = copy._speedExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._speedExpressions.length === 0) {
                return this;
              }
              const copy = new SineWaveMover(this);
              copy._speedExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._speedExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new SineWaveMover(this);
              copy._speedExpressions = copy._speedExpressions.slice();
              copy._speedExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new SineWaveMover(this);
              copy._speedExpressions = copy._speedExpressions.slice(0, path[1]).concat(copy._speedExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._speedExpressions.length) {
            return this;
          }
          const oldValue = this._speedExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new SineWaveMover(this);
          copy._speedExpressions = copy._speedExpressions.slice();
          copy._speedExpressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SineWaveMover} other
   * @returns {SineWaveMover}
   */
  merge(other) {
    const copy = new SineWaveMover(this);
    if (other._hasAmplitude) {
      copy._hasAmplitude = true;
      copy._amplitude = other._amplitude;
    }
    if (other._hasPeakCount) {
      copy._hasPeakCount = true;
      copy._peakCount = other._peakCount;
    }
    if (other._hasSpeed) {
      copy._hasSpeed = true;
      copy._speed = other._speed;
    }
    copy._speedExpressions = this._speedExpressions.concat(other._speedExpressions);
    return copy;
  }
}
SineWaveMover.default = new SineWaveMover();
class SineWaveMover_Builder {
  constructor(value) {
    this._value = new SineWaveMover(value);
  }
  build() {
    return new SineWaveMover(this._value);
  }
  setAmplitude(value) {
    this._value._hasAmplitude = true;
    this._value._amplitude = value;
    return this;
  }
  deleteAmplitude() {
    this._value._hasAmplitude = false;
    this._value._amplitude = null;
    return this;
  }
  setPeakCount(value) {
    this._value._hasPeakCount = true;
    this._value._peakCount = value;
    return this;
  }
  deletePeakCount() {
    this._value._hasPeakCount = false;
    this._value._peakCount = null;
    return this;
  }
  setSpeed(value) {
    this._value._hasSpeed = true;
    this._value._speed = value;
    return this;
  }
  deleteSpeed() {
    this._value._hasSpeed = false;
    this._value._speed = null;
    return this;
  }
  addAllSpeedExpressions(values) {
    this._value._speedExpressions = this._value._speedExpressions.concat(values);
    return this;
  }
  addSpeedExpressions(value) {
    this._value._speedExpressions = this._value._speedExpressions.concat([value]);
    return this;
  }
  setSpeedExpressions(index, value) {
    this._value._speedExpressions = this._value._speedExpressions.concat();
    this._value._speedExpressions[index] = value;
    return this;
  }
  clearSpeedExpressions() {
    this._value._speedExpressions = [];
    return this;
  }
}
SineWaveMover.Builder = SineWaveMover_Builder;
class SineWaveMover_WithParent {
  /**
   * @param {SineWaveMover} value
   * @param {SineWaveMover_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SineWaveMover.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAmplitude() {
    if (this._cachedHasAmplitude === undefined) {
      if (this._value.hasAmplitude) {
        this._cachedHasAmplitude = true;
      } else {
        this._cachedHasAmplitude = this._parent ? this._parent.hasAmplitude : false;
      }
    }
    return this._cachedHasAmplitude;
  }
  get amplitude() {
    if (this._cachedAmplitude === undefined) {
      if (this._value.hasAmplitude) {
        this._cachedAmplitude = this._value.amplitude;
      } else {
        this._cachedAmplitude = this._parent ? this._parent.amplitude : this._value.amplitude;
      }
    }
    return this._cachedAmplitude;
  }
  get hasPeakCount() {
    if (this._cachedHasPeakCount === undefined) {
      if (this._value.hasPeakCount) {
        this._cachedHasPeakCount = true;
      } else {
        this._cachedHasPeakCount = this._parent ? this._parent.hasPeakCount : false;
      }
    }
    return this._cachedHasPeakCount;
  }
  get peakCount() {
    if (this._cachedPeakCount === undefined) {
      if (this._value.hasPeakCount) {
        this._cachedPeakCount = this._value.peakCount;
      } else {
        this._cachedPeakCount = this._parent ? this._parent.peakCount : this._value.peakCount;
      }
    }
    return this._cachedPeakCount;
  }
  get hasSpeed() {
    if (this._cachedHasSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedHasSpeed = true;
      } else {
        this._cachedHasSpeed = this._parent ? this._parent.hasSpeed : false;
      }
    }
    return this._cachedHasSpeed;
  }
  get speed() {
    if (this._cachedSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedSpeed = this._value.speed;
      } else {
        this._cachedSpeed = this._parent ? this._parent.speed : this._value.speed;
      }
    }
    return this._cachedSpeed;
  }
  get selfSpeedExpressions() {
    if (!this._selfSpeedExpressions) {
      this._selfSpeedExpressions = [];
      for (let i of this._value.speedExpressions) {
        this._selfSpeedExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfSpeedExpressions;
  }
  get inherentSpeedExpressions() {
    if (!this._inherentSpeedExpressions) {
      this._inherentSpeedExpressions = this._parent ? this._parent.speedExpressions : [];
    }
    return this._inherentSpeedExpressions;
  }
  get speedExpressions() {
    if (!this._allSpeedExpressions) {
      this._allSpeedExpressions = this._parent ? this._parent.speedExpressions.concat(this.selfSpeedExpressions) : this.selfSpeedExpressions;
    }
    return this._allSpeedExpressions;
  }
  update(current, parent) {
    const result = new SineWaveMover_WithParent(current, parent);
    if (this._selfSpeedExpressions) {
      if (this._value.speedExpressions === current.speedExpressions) {
        result._selfSpeedExpressions = this._selfSpeedExpressions;
      } else {
        result._selfSpeedExpressions = [];
        for (let i = 0; i < current.speedExpressions.length; i++) {
          const oldValue = this._value.speedExpressions[i];
          if (oldValue) {
            const oldCache = this._selfSpeedExpressions[i];
            if (oldValue === current.speedExpressions[i]) {
              result._selfSpeedExpressions[i] = oldCache;
            } else {
              result._selfSpeedExpressions[i] = oldCache.update(current.speedExpressions[i], null);
            }
          } else {
            result._selfSpeedExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.speedExpressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
SineWaveMover_WithParent.default = new SineWaveMover_WithParent(SineWaveMover.default, null);
SineWaveMover.WithParent = SineWaveMover_WithParent;
class SineWaveMover_Descriptor {
  get amplitude() {
    if (!this._amplitude) {
      this._amplitude = {
        name: "amplitude",
        Name: "Amplitude",
        number: 1,
        protoType: 1,
        protoName: "amplitude",
        type: JsonToDouble,
        options: {
          comments: "The width of the wave. Positive values mean the wave will start from the left while negative values mean the wave will start from the right. If set to 0, there will be no wave motion.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amplitude;
  }
  get peakCount() {
    if (!this._peakCount) {
      this._peakCount = {
        name: "peakCount",
        Name: "PeakCount",
        number: 2,
        protoType: 5,
        protoName: "peak_count",
        type: JsonToInt32,
        options: {
          comments: "The number of peaks the wave will make between its origin and target. If set to 0, one peak will be used.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._peakCount;
  }
  get speed() {
    if (!this._speed) {
      this._speed = {
        name: "speed",
        Name: "Speed",
        number: 3,
        protoType: 1,
        protoName: "speed",
        type: JsonToDouble,
        options: {
          comments: "The missile unit\'s speed, in terrain grid-units-per-second.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speed;
  }
  get speedExpressions() {
    if (!this._speedExpressions) {
      this._speedExpressions = {
        name: "speedExpressions",
        Name: "SpeedExpressions",
        number: 4,
        protoType: 11,
        protoName: "speed_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "If set, the evaluated expression will be added to the speed when the missile unit is launched.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speedExpressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.amplitude,
        this.peakCount,
        this.speed,
        this.speedExpressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAmplitude",
        Name: "DummyOneofForAmplitude",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPeakCount",
        Name: "DummyOneofForPeakCount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpeed",
        Name: "DummyOneofForSpeed",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
SineWaveMover.descriptor = new SineWaveMover_Descriptor();
export class OrbitingMover {
  get descriptor() {
    return OrbitingMover.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._orbitSpeedTypeCase = 0;
    this._orbitSpeedTypeValue = null;
    this._hasBindToOwner = false;
    this._bindToOwner = null;
    this._hasLifePeriod = false;
    this._lifePeriod = null;
    this._hasAxis = false;
    this._axis = null;
    this._hasRadius = false;
    this._radius = null;
    this._radiusExpressions = [];
  }
  isEmpty() {
    if (this._orbitSpeedTypeCase !== 0) return false;
    if (this._hasBindToOwner) return false;
    if (this._hasLifePeriod) return false;
    if (this._hasAxis && !this._axis.isEmpty()) return false;
    if (this._hasRadius) return false;
    if (this._radiusExpressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof OrbitingMover) {
      return value;
    }
    return OrbitingMover.fromJson(value);
  }
  static fromJson(json) {
    const result = new OrbitingMover();
    if (json.speed != null) {
      result._orbitSpeedTypeCase = 101;
      result._orbitSpeedTypeValue = JsonToDouble.fromJson(json.speed);
    }
    if (json.degreePerSecond != null) {
      result._orbitSpeedTypeCase = 102;
      result._orbitSpeedTypeValue = JsonToDouble.fromJson(json.degreePerSecond);
    }
    if (json.bindToOwner != null) {
      result._hasBindToOwner = true;
      result._bindToOwner = JsonToBoolean.fromJson(json.bindToOwner);
    }
    if (json.lifePeriod != null) {
      result._hasLifePeriod = true;
      result._lifePeriod = JsonToDouble.fromJson(json.lifePeriod);
    }
    if (json.axis != null) {
      result._hasAxis = true;
      result._axis = dcei_engine_effect_proto.EffectOffset.fromJson(json.axis);
    }
    if (json.radius != null) {
      result._hasRadius = true;
      result._radius = JsonToDouble.fromJson(json.radius);
    }
    result._radiusExpressions = JsonToList(json.radiusExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._orbitSpeedTypeCase) {
      case 101:
        result.speed = JsonToDouble.toJson(this._orbitSpeedTypeValue);
        break;
      case 102:
        result.degreePerSecond = JsonToDouble.toJson(this._orbitSpeedTypeValue);
        break;
      default:
        break;
    }
    if (this._hasBindToOwner) {
      result.bindToOwner = JsonToBoolean.toJson(this._bindToOwner);
    }
    if (this._hasLifePeriod) {
      result.lifePeriod = JsonToDouble.toJson(this._lifePeriod);
    }
    if (this._hasAxis && !this._axis.isEmpty()) {
      result.axis = dcei_engine_effect_proto.EffectOffset.toJson(this._axis);
    }
    if (this._hasRadius) {
      result.radius = JsonToDouble.toJson(this._radius);
    }
    if (this._radiusExpressions.length > 0) {
      result.radiusExpressions = ArrayToJson(this._radiusExpressions, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    return result;
  }
  get orbitSpeedTypeCase() {
    return this._orbitSpeedTypeCase;
  }
  deleteOrbitSpeedType(path) {
    switch (this._orbitSpeedTypeCase) {
      default:
      case 101: {
        return {type: 'DELETE', path: path.concat(['speed'])};
      }
      case 102: {
        return {type: 'DELETE', path: path.concat(['degreePerSecond'])};
      }
    }
  }
  /**
   * @returns {number}
   */
  get speed() {
    return this._orbitSpeedTypeCase === 101 ? this._orbitSpeedTypeValue : JsonToDouble.default;
  }
  setSpeed(path, value) {
    return {type: 'SET', path: path.concat(['speed']), value};
  }
  deleteSpeed(path) {
    return {type: 'DELETE', path: path.concat(['speed'])};
  }
  /**
   * @returns {number}
   */
  get degreePerSecond() {
    return this._orbitSpeedTypeCase === 102 ? this._orbitSpeedTypeValue : JsonToDouble.default;
  }
  setDegreePerSecond(path, value) {
    return {type: 'SET', path: path.concat(['degreePerSecond']), value};
  }
  deleteDegreePerSecond(path) {
    return {type: 'DELETE', path: path.concat(['degreePerSecond'])};
  }
  /**
   * @returns {boolean}
   */
  get bindToOwner() {
    return this._hasBindToOwner ? this._bindToOwner : JsonToBoolean.default;
  }
  get hasBindToOwner() {
    return this._hasBindToOwner;
  }
  setBindToOwner(path, value) {
    return {type: 'SET', path: path.concat(['bindToOwner']), value};
  }
  deleteBindToOwner(path) {
    return {type: 'DELETE', path: path.concat(['bindToOwner'])};
  }
  /**
   * @returns {number}
   */
  get lifePeriod() {
    return this._hasLifePeriod ? this._lifePeriod : JsonToDouble.default;
  }
  get hasLifePeriod() {
    return this._hasLifePeriod;
  }
  setLifePeriod(path, value) {
    return {type: 'SET', path: path.concat(['lifePeriod']), value};
  }
  deleteLifePeriod(path) {
    return {type: 'DELETE', path: path.concat(['lifePeriod'])};
  }
  /**
   * @returns {dcei_engine_effect_proto.EffectOffset}
   */
  get axis() {
    return this._hasAxis ? this._axis : dcei_engine_effect_proto.EffectOffset.default;
  }
  get hasAxis() {
    return this._hasAxis;
  }
  setAxis(path, value) {
    return {type: 'SET', path: path.concat(['axis']), value: value.toJson()};
  }
  deleteAxis(path) {
    return {type: 'DELETE', path: path.concat(['axis'])};
  }
  /**
   * @returns {number}
   */
  get radius() {
    return this._hasRadius ? this._radius : JsonToDouble.default;
  }
  get hasRadius() {
    return this._hasRadius;
  }
  setRadius(path, value) {
    return {type: 'SET', path: path.concat(['radius']), value};
  }
  deleteRadius(path) {
    return {type: 'DELETE', path: path.concat(['radius'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression[]}
   */
  get radiusExpressions() {
    return this._radiusExpressions;
  }
  addRadiusExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['radiusExpressions']), value: value.toJson()};
  }
  setRadiusExpressions(path, value) {
    return {type: 'SET', path: path.concat(['radiusExpressions']), value: ArrayToJson(value, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setRadiusExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['radiusExpressions', key]), value: value.toJson()};
  }
  deleteRadiusExpressions(path) {
    return {type: 'DELETE', path: path.concat(['radiusExpressions'])};
  }
  deleteRadiusExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['radiusExpressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "speed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OrbitingMover(this);
              copy._orbitSpeedTypeCase = 101;
              copy._orbitSpeedTypeValue = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._orbitSpeedTypeCase !== 101) {
                return this;
              }
              const copy = new OrbitingMover(this);
              copy._orbitSpeedTypeCase = 0;
              copy._orbitSpeedTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "degreePerSecond": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OrbitingMover(this);
              copy._orbitSpeedTypeCase = 102;
              copy._orbitSpeedTypeValue = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._orbitSpeedTypeCase !== 102) {
                return this;
              }
              const copy = new OrbitingMover(this);
              copy._orbitSpeedTypeCase = 0;
              copy._orbitSpeedTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bindToOwner": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OrbitingMover(this);
              copy._hasBindToOwner = true;
              copy._bindToOwner = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBindToOwner) {
                return this;
              }
              const copy = new OrbitingMover(this);
              copy._hasBindToOwner = false;
              copy._bindToOwner = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "lifePeriod": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OrbitingMover(this);
              copy._hasLifePeriod = true;
              copy._lifePeriod = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLifePeriod) {
                return this;
              }
              const copy = new OrbitingMover(this);
              copy._hasLifePeriod = false;
              copy._lifePeriod = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "axis": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OrbitingMover(this);
              copy._hasAxis = true;
              copy._axis = dcei_engine_effect_proto.EffectOffset.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAxis) {
                return this;
              }
              const copy = new OrbitingMover(this);
              copy._hasAxis = false;
              copy._axis = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAxis) {
            const copy = new OrbitingMover(this);
            copy._hasAxis = true;
            copy._axis = dcei_engine_effect_proto.EffectOffset.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._axis.apply(type, path.slice(1), value);
          if (newValue === this._axis) {
            return this;
          }
          const copy = new OrbitingMover(this);
          copy._axis = copy._axis.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "radius": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OrbitingMover(this);
              copy._hasRadius = true;
              copy._radius = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRadius) {
                return this;
              }
              const copy = new OrbitingMover(this);
              copy._hasRadius = false;
              copy._radius = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "radiusExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new OrbitingMover(this);
              copy._radiusExpressions = [];        for (let i of value) {
                copy._radiusExpressions.push(dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new OrbitingMover(this);
              copy._radiusExpressions = copy._radiusExpressions.concat([dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._radiusExpressions.length === 0) {
                return this;
              }
              const copy = new OrbitingMover(this);
              copy._radiusExpressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._radiusExpressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new OrbitingMover(this);
              copy._radiusExpressions = copy._radiusExpressions.slice();
              copy._radiusExpressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new OrbitingMover(this);
              copy._radiusExpressions = copy._radiusExpressions.slice(0, path[1]).concat(copy._radiusExpressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._radiusExpressions.length) {
            return this;
          }
          const oldValue = this._radiusExpressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new OrbitingMover(this);
          copy._radiusExpressions = copy._radiusExpressions.slice();
          copy._radiusExpressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {OrbitingMover} other
   * @returns {OrbitingMover}
   */
  merge(other) {
    const copy = new OrbitingMover(this);
    if (other._orbitSpeedTypeCase === 101) {
      copy._orbitSpeedTypeCase = 101;
      copy._orbitSpeedTypeValue = other._orbitSpeedTypeValue;
    }
    if (other._orbitSpeedTypeCase === 101) {
      copy._orbitSpeedTypeCase = 101;
      copy._orbitSpeedTypeValue = other._orbitSpeedTypeValue;
    }
    if (other._hasBindToOwner) {
      copy._hasBindToOwner = true;
      copy._bindToOwner = other._bindToOwner;
    }
    if (other._hasLifePeriod) {
      copy._hasLifePeriod = true;
      copy._lifePeriod = other._lifePeriod;
    }
    if (other._hasAxis) {
      if (copy._hasAxis) {
        copy._axis = copy.axis.merge(other.axis);
      } else {
        copy._axis = other._axis;
      }
      copy._hasAxis = true;
    }
    if (other._hasRadius) {
      copy._hasRadius = true;
      copy._radius = other._radius;
    }
    copy._radiusExpressions = this._radiusExpressions.concat(other._radiusExpressions);
    return copy;
  }
}
OrbitingMover.default = new OrbitingMover();
class OrbitingMover_Builder {
  constructor(value) {
    this._value = new OrbitingMover(value);
  }
  build() {
    return new OrbitingMover(this._value);
  }
  clearorbitSpeedType() {
    this._value._orbitSpeedTypeCase = 0;
    this._value._orbitSpeedTypeValue = null;
    return this;
  }
  setSpeed(value) {
    this._value._orbitSpeedTypeCase = 101;
    this._value._orbitSpeedTypeValue = value;
    return this;
  }
  setDegreePerSecond(value) {
    this._value._orbitSpeedTypeCase = 102;
    this._value._orbitSpeedTypeValue = value;
    return this;
  }
  setBindToOwner(value) {
    this._value._hasBindToOwner = true;
    this._value._bindToOwner = value;
    return this;
  }
  deleteBindToOwner() {
    this._value._hasBindToOwner = false;
    this._value._bindToOwner = null;
    return this;
  }
  setLifePeriod(value) {
    this._value._hasLifePeriod = true;
    this._value._lifePeriod = value;
    return this;
  }
  deleteLifePeriod() {
    this._value._hasLifePeriod = false;
    this._value._lifePeriod = null;
    return this;
  }
  setAxis(value) {
    this._value._hasAxis = true;
    this._value._axis = value;
    return this;
  }
  deleteAxis() {
    this._value._hasAxis = false;
    this._value._axis = null;
    return this;
  }
  setRadius(value) {
    this._value._hasRadius = true;
    this._value._radius = value;
    return this;
  }
  deleteRadius() {
    this._value._hasRadius = false;
    this._value._radius = null;
    return this;
  }
  addAllRadiusExpressions(values) {
    this._value._radiusExpressions = this._value._radiusExpressions.concat(values);
    return this;
  }
  addRadiusExpressions(value) {
    this._value._radiusExpressions = this._value._radiusExpressions.concat([value]);
    return this;
  }
  setRadiusExpressions(index, value) {
    this._value._radiusExpressions = this._value._radiusExpressions.concat();
    this._value._radiusExpressions[index] = value;
    return this;
  }
  clearRadiusExpressions() {
    this._value._radiusExpressions = [];
    return this;
  }
}
OrbitingMover.Builder = OrbitingMover_Builder;
class OrbitingMover_WithParent {
  /**
   * @param {OrbitingMover} value
   * @param {OrbitingMover_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return OrbitingMover.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get orbitSpeedTypeCase() {
    if (this._cachedorbitSpeedTypeCase === undefined) {
      if (this._value._orbitSpeedTypeCase === 0) {
        this._cachedorbitSpeedTypeCase = this._parent ? this._parent.orbitSpeedTypeCase : 0;
      } else {
        this._cachedorbitSpeedTypeCase = this._value._orbitSpeedTypeCase;
      }
    }
    return this._cachedorbitSpeedTypeCase;
  }
  get speed() {
    if (!this._cachedSpeed) {
      if (this._value._orbitSpeedTypeCase === 0) {
        this._cachedSpeed = this._parent ? this._parent.speed : this._value.speed;
      } else {
        this._cachedSpeed = this._value.speed;
      }
    }
    return this._cachedSpeed;
  }
  get degreePerSecond() {
    if (!this._cachedDegreePerSecond) {
      if (this._value._orbitSpeedTypeCase === 0) {
        this._cachedDegreePerSecond = this._parent ? this._parent.degreePerSecond : this._value.degreePerSecond;
      } else {
        this._cachedDegreePerSecond = this._value.degreePerSecond;
      }
    }
    return this._cachedDegreePerSecond;
  }
  get hasBindToOwner() {
    if (this._cachedHasBindToOwner === undefined) {
      if (this._value.hasBindToOwner) {
        this._cachedHasBindToOwner = true;
      } else {
        this._cachedHasBindToOwner = this._parent ? this._parent.hasBindToOwner : false;
      }
    }
    return this._cachedHasBindToOwner;
  }
  get bindToOwner() {
    if (this._cachedBindToOwner === undefined) {
      if (this._value.hasBindToOwner) {
        this._cachedBindToOwner = this._value.bindToOwner;
      } else {
        this._cachedBindToOwner = this._parent ? this._parent.bindToOwner : this._value.bindToOwner;
      }
    }
    return this._cachedBindToOwner;
  }
  get hasLifePeriod() {
    if (this._cachedHasLifePeriod === undefined) {
      if (this._value.hasLifePeriod) {
        this._cachedHasLifePeriod = true;
      } else {
        this._cachedHasLifePeriod = this._parent ? this._parent.hasLifePeriod : false;
      }
    }
    return this._cachedHasLifePeriod;
  }
  get lifePeriod() {
    if (this._cachedLifePeriod === undefined) {
      if (this._value.hasLifePeriod) {
        this._cachedLifePeriod = this._value.lifePeriod;
      } else {
        this._cachedLifePeriod = this._parent ? this._parent.lifePeriod : this._value.lifePeriod;
      }
    }
    return this._cachedLifePeriod;
  }
  get hasAxis() {
    if (this._cachedHasAxis === undefined) {
      if (this._value.hasAxis) {
        this._cachedHasAxis = true;
      } else {
        this._cachedHasAxis = this._parent ? this._parent.hasAxis : false;
      }
    }
    return this._cachedHasAxis;
  }
  get axis() {
    if (!this._cachedAxis) {
      if (this._value.hasAxis) {
        this._cachedAxis = new dcei_engine_effect_proto.EffectOffset.WithParent(this._value.axis, this._parent && this._parent.hasAxis ? this._parent.axis : null);
      } else {
        this._cachedAxis = this._parent ? new dcei_engine_effect_proto.EffectOffset.WithParent(dcei_engine_effect_proto.EffectOffset.default, this._parent.axis) : dcei_engine_effect_proto.EffectOffset.WithParent.default;
      }
    }
    return this._cachedAxis;
  }
  get hasRadius() {
    if (this._cachedHasRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedHasRadius = true;
      } else {
        this._cachedHasRadius = this._parent ? this._parent.hasRadius : false;
      }
    }
    return this._cachedHasRadius;
  }
  get radius() {
    if (this._cachedRadius === undefined) {
      if (this._value.hasRadius) {
        this._cachedRadius = this._value.radius;
      } else {
        this._cachedRadius = this._parent ? this._parent.radius : this._value.radius;
      }
    }
    return this._cachedRadius;
  }
  get selfRadiusExpressions() {
    if (!this._selfRadiusExpressions) {
      this._selfRadiusExpressions = [];
      for (let i of this._value.radiusExpressions) {
        this._selfRadiusExpressions.push(new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(i, null));
      }
    }
    return this._selfRadiusExpressions;
  }
  get inherentRadiusExpressions() {
    if (!this._inherentRadiusExpressions) {
      this._inherentRadiusExpressions = this._parent ? this._parent.radiusExpressions : [];
    }
    return this._inherentRadiusExpressions;
  }
  get radiusExpressions() {
    if (!this._allRadiusExpressions) {
      this._allRadiusExpressions = this._parent ? this._parent.radiusExpressions.concat(this.selfRadiusExpressions) : this.selfRadiusExpressions;
    }
    return this._allRadiusExpressions;
  }
  update(current, parent) {
    const result = new OrbitingMover_WithParent(current, parent);
    if (this._cachedAxis && this._value.hasAxis && current.hasAxis) {
      if (this._value.axis === current.axis && this._parent === parent) {
        result._cachedAxis = this._cachedAxis;
      } else {
        result._cachedAxis = this._cachedAxis.update(current.axis, parent && parent.hasAxis ? parent.axis : null);
      }
    }
    if (this._selfRadiusExpressions) {
      if (this._value.radiusExpressions === current.radiusExpressions) {
        result._selfRadiusExpressions = this._selfRadiusExpressions;
      } else {
        result._selfRadiusExpressions = [];
        for (let i = 0; i < current.radiusExpressions.length; i++) {
          const oldValue = this._value.radiusExpressions[i];
          if (oldValue) {
            const oldCache = this._selfRadiusExpressions[i];
            if (oldValue === current.radiusExpressions[i]) {
              result._selfRadiusExpressions[i] = oldCache;
            } else {
              result._selfRadiusExpressions[i] = oldCache.update(current.radiusExpressions[i], null);
            }
          } else {
            result._selfRadiusExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.radiusExpressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
OrbitingMover_WithParent.default = new OrbitingMover_WithParent(OrbitingMover.default, null);
OrbitingMover.WithParent = OrbitingMover_WithParent;
class OrbitingMover_Descriptor {
  get speed() {
    if (!this._speed) {
      this._speed = {
        name: "speed",
        Name: "Speed",
        number: 101,
        protoType: 1,
        protoName: "speed",
        oneofIndex: 0,
        type: JsonToDouble,
        options: {
          comments: "When set, the missile unit\'s orbit speed, in terrain grid-units-per-second.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speed;
  }
  get degreePerSecond() {
    if (!this._degreePerSecond) {
      this._degreePerSecond = {
        name: "degreePerSecond",
        Name: "DegreePerSecond",
        number: 102,
        protoType: 1,
        protoName: "degree_per_second",
        oneofIndex: 0,
        type: JsonToDouble,
        options: {
          comments: "When set, the missile unit\'s orbit speed, in degrees-per-second.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._degreePerSecond;
  }
  get bindToOwner() {
    if (!this._bindToOwner) {
      this._bindToOwner = {
        name: "bindToOwner",
        Name: "BindToOwner",
        number: 1,
        protoType: 8,
        protoName: "bind_to_owner",
        type: JsonToBoolean,
        options: {
          comments: "When checked, the mover will be destroyed if the caster dies.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bindToOwner;
  }
  get lifePeriod() {
    if (!this._lifePeriod) {
      this._lifePeriod = {
        name: "lifePeriod",
        Name: "LifePeriod",
        number: 2,
        protoType: 1,
        protoName: "life_period",
        type: JsonToDouble,
        options: {
          comments: "When set, the missile unit will die after this duration.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._lifePeriod;
  }
  get axis() {
    if (!this._axis) {
      this._axis = {
        name: "axis",
        Name: "Axis",
        number: 3,
        protoType: 11,
        protoName: "axis",
        type: dcei_engine_effect_proto.EffectOffset,
        options: {
          comments: "Sets the axis of rotation for the orbit. The default axis is 0, 0, 1 for a clockwise rotation. An axis of 0, 0, -1 will create a counter-clockwise rotation.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._axis;
  }
  get radius() {
    if (!this._radius) {
      this._radius = {
        name: "radius",
        Name: "Radius",
        number: 4,
        protoType: 1,
        protoName: "radius",
        type: JsonToDouble,
        options: {
          comments: "The radius of the orbit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._radius;
  }
  get radiusExpressions() {
    if (!this._radiusExpressions) {
      this._radiusExpressions = {
        name: "radiusExpressions",
        Name: "RadiusExpressions",
        number: 5,
        protoType: 11,
        protoName: "radius_expressions",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        isRepeated: true,
        options: {
          comments: "If set, the evaluated expression will be added to the radius when the missile unit is launched.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._radiusExpressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.speed,
        this.degreePerSecond,
        this.bindToOwner,
        this.lifePeriod,
        this.axis,
        this.radius,
        this.radiusExpressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "orbitSpeedType",
        Name: "OrbitSpeedType",
        fields: [
          this.fields[0],
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBindToOwner",
        Name: "DummyOneofForBindToOwner",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLifePeriod",
        Name: "DummyOneofForLifePeriod",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAxis",
        Name: "DummyOneofForAxis",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRadius",
        Name: "DummyOneofForRadius",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
OrbitingMover.descriptor = new OrbitingMover_Descriptor();
